export type networkStatusType = "ONLINE" | "OFFLINE";
export const NETWORK_STATUS = {
    ONLINE: ("NETWORK_STATUS_ONLINE" as networkStatusType),
    OFFLINE: ("NETWORK_STATUS_OFFLINE" as networkStatusType)
};
export type windowType = "RESIZE" | "OFFLINE" | "BEFORE_PRINT" | "AFTER_PRINT" | "CUT" | "COPY" | "PASTE" | "FULLSCREEN_CHANGE" | "FULLSCREEN_ERROR" | "ERROR";
export const WINDOW = {
    RESIZE: ("WINDOW_RESIZE" as windowType),
    OFFLINE: ("WINDOW_OFFLINE" as windowType),
    BEFORE_PRINT: ("WINDOW_BEFORE_PRINT" as windowType),
    AFTER_PRINT: ("WINDOW_AFTER_PRINT" as windowType),
    CUT: ("WINDOW_CUT" as windowType),
    COPY: ("WINDOW_COPY" as windowType),
    PASTE: ("WINDOW_PASTE" as windowType),
    FULLSCREEN_CHANGE: ("WINDOW_FULLSCREEN_CHANGE" as windowType),
    FULLSCREEN_ERROR: ("WINDOW_FULLSCREEN_ERROR" as windowType),
    ERROR: ("WINDOW_ERROR" as windowType)
};
export type appType = "INIT" | "DESTROY";
export const APP = {
    INIT: ("APP_INIT" as appType),
    DESTROY: ("APP_DESTROY" as appType)
};
export type popupType = "INIT" | "DESTROY" | "CLOSE";
export const POPUP = {
    INIT: ("POPUP_INIT" as popupType),
    DESTROY: ("POPUP_DESTROY" as popupType),
    CLOSE: ("POPUP_CLOSE" as popupType)
};
export type emailEditType = "INIT" | "DESTROY" | "CLICK_SUBMIT" | "UPDATE_FORM";
export const EMAIL_EDIT = {
    INIT: ("EMAIL_EDIT_INIT" as emailEditType),
    DESTROY: ("EMAIL_EDIT_DESTROY" as emailEditType),
    CLICK_SUBMIT: ("EMAIL_EDIT_CLICK_SUBMIT" as emailEditType),
    UPDATE_FORM: ("EMAIL_EDIT_UPDATE_FORM" as emailEditType)
};
export type authType = "APPLY_ACTION_CODE" | "APPLY_ACTION_CODE_SUCCESS" | "APPLY_ACTION_CODE_FAILURE" | "CHECK_ACTION_CODE" | "CHECK_ACTION_CODE_SUCCESS" | "CHECK_ACTION_CODE_FAILURE" | "CONFIRM_PASSWORD_RESET" | "CONFIRM_PASSWORD_RESET_SUCCESS" | "CONFIRM_PASSWORD_RESET_FAILURE" | "CREATE_USER_WITH_EMAIL_AND_PASSWORD" | "CREATE_USER_WITH_EMAIL_AND_PASSWORD_SUCCESS" | "CREATE_USER_WITH_EMAIL_AND_PASSWORD_FAILURE" | "GET_REDIRECT_RESULT" | "GET_REDIRECT_RESULT_SUCCESS" | "GET_REDIRECT_RESULT_FAILURE" | "IS_SIGN_IN_WITH_EMAIL_LINK" | "ON_AUTH_STATE_CHANGED" | "ON_ID_TOKEN_CHANGED" | "SEND_PASSWORD_RESET_EMAIL" | "SEND_PASSWORD_RESET_EMAIL_SUCCESS" | "SEND_PASSWORD_RESET_EMAIL_FAILURE" | "SEND_SIGN_IN_LINK_TO_EMAIL" | "SEND_SIGN_IN_LINK_TO_EMAIL_SUCCESS" | "SEND_SIGN_IN_LINK_TO_EMAIL_FAILURE" | "SET_PERSISTENCE" | "SET_PERSISTENCE_SUCCESS" | "SET_PERSISTENCE_FAILURE" | "SIGN_IN_AND_RETRIEVE_DATA_WITH_CREDENTIAL" | "SIGN_IN_AND_RETRIEVE_DATA_WITH_CREDENTIAL_SUCCESS" | "SIGN_IN_AND_RETRIEVE_DATA_WITH_CREDENTIAL_FAILURE" | "SIGN_IN_ANONYMOUSLY" | "SIGN_IN_ANONYMOUSLY_SUCCESS" | "SIGN_IN_ANONYMOUSLY_FAILURE" | "SIGN_IN_WITH_CUSTOM_TOKEN" | "SIGN_IN_WITH_CUSTOM_TOKEN_SUCCESS" | "SIGN_IN_WITH_CUSTOM_TOKEN_FAILURE" | "SIGN_IN_WITH_EMAIL_AND_PASSWORD" | "SIGN_IN_WITH_EMAIL_AND_PASSWORD_SUCCESS" | "SIGN_IN_WITH_EMAIL_AND_PASSWORD_FAILURE" | "SIGN_IN_WITH_EMAIL_LINK" | "SIGN_IN_WITH_EMAIL_LINK_SUCCESS" | "SIGN_IN_WITH_EMAIL_LINK_FAILURE" | "SIGN_IN_WITH_PHONE_NUMBER" | "SIGN_IN_WITH_PHONE_NUMBER_SUCCESS" | "SIGN_IN_WITH_PHONE_NUMBER_FAILURE" | "SIGN_IN_WITH_POPUP" | "SIGN_IN_WITH_POPUP_SUCCESS" | "SIGN_IN_WITH_POPUP_FAILURE" | "SIGN_IN_WITH_REDIRECT" | "SIGN_IN_WITH_REDIRECT_SUCCESS" | "SIGN_IN_WITH_REDIRECT_FAILURE" | "SIGN_OUT" | "SIGN_OUT_SUCCESS" | "SIGN_OUT_FAILURE" | "UPDATE_CURRENT_USER" | "UPDATE_CURRENT_USER_SUCCESS" | "UPDATE_CURRENT_USER_FAILURE" | "VERIFY_PASSWORD_RESET_CODE" | "VERIFY_PASSWORD_RESET_CODE_SUCCESS" | "VERIFY_PASSWORD_RESET_CODE_FAILURE" | "RELOAD" | "RELOAD_SUCCESS" | "RELOAD_FAILURE" | "INIT" | "DESTROY" | "AFTER_INIT" | "CLICK_BACK_LINK" | "LOGIN" | "LOGIN_SUCCESS" | "LOGIN_FAILURE" | "LOGOUT" | "LOGOUT_SUCCESS" | "LOGOUT_FAILURE" | "FORGOT_PASSWORD" | "FORGOT_PASSWORD_SUCCESS" | "FORGOT_PASSWORD_FAILURE" | "RESET_PASSWORD_UPDATE" | "RESET_PASSWORD_UPDATE_SUCCESS" | "RESET_PASSWORD_UPDATE_FAILURE" | "VALIDATE_CODE" | "VALIDATE_CODE_SUCCESS" | "VALIDATE_CODE_FAILURE" | "REGISTER_EMAIL" | "REGISTER_EMAIL_SUCCESS" | "REGISTER_EMAIL_FAILURE" | "SEND_EMAIL_VERIFICATION_LINK" | "SEND_EMAIL_VERIFICATION_LINK_SUCCESS" | "SEND_EMAIL_VERIFICATION_LINK_FAILURE" | "VALIDATE_EMAIL_CODE" | "VALIDATE_EMAIL_CODE_SUCCESS" | "VALIDATE_EMAIL_CODE_FAILURE" | "STATE_SUCCESS" | "STATE_FAILURE" | "READY" | "UPDATE_PASSWORD" | "UPDATE_PASSWORD_SUCCESS" | "UPDATE_PASSWORD_FAILURE" | "UPDATE_EMAIL" | "UPDATE_EMAIL_SUCCESS" | "UPDATE_EMAIL_FAILURE";
export const AUTH = {
    APPLY_ACTION_CODE: ("AUTH_APPLY_ACTION_CODE" as authType),
    APPLY_ACTION_CODE_SUCCESS: ("AUTH_APPLY_ACTION_CODE_SUCCESS" as authType),
    APPLY_ACTION_CODE_FAILURE: ("AUTH_APPLY_ACTION_CODE_FAILURE" as authType),
    CHECK_ACTION_CODE: ("AUTH_CHECK_ACTION_CODE" as authType),
    CHECK_ACTION_CODE_SUCCESS: ("AUTH_CHECK_ACTION_CODE_SUCCESS" as authType),
    CHECK_ACTION_CODE_FAILURE: ("AUTH_CHECK_ACTION_CODE_FAILURE" as authType),
    CONFIRM_PASSWORD_RESET: ("AUTH_CONFIRM_PASSWORD_RESET" as authType),
    CONFIRM_PASSWORD_RESET_SUCCESS: ("AUTH_CONFIRM_PASSWORD_RESET_SUCCESS" as authType),
    CONFIRM_PASSWORD_RESET_FAILURE: ("AUTH_CONFIRM_PASSWORD_RESET_FAILURE" as authType),
    CREATE_USER_WITH_EMAIL_AND_PASSWORD: ("AUTH_CREATE_USER_WITH_EMAIL_AND_PASSWORD" as authType),
    CREATE_USER_WITH_EMAIL_AND_PASSWORD_SUCCESS: ("AUTH_CREATE_USER_WITH_EMAIL_AND_PASSWORD_SUCCESS" as authType),
    CREATE_USER_WITH_EMAIL_AND_PASSWORD_FAILURE: ("AUTH_CREATE_USER_WITH_EMAIL_AND_PASSWORD_FAILURE" as authType),
    GET_REDIRECT_RESULT: ("AUTH_GET_REDIRECT_RESULT" as authType),
    GET_REDIRECT_RESULT_SUCCESS: ("AUTH_GET_REDIRECT_RESULT_SUCCESS" as authType),
    GET_REDIRECT_RESULT_FAILURE: ("AUTH_GET_REDIRECT_RESULT_FAILURE" as authType),
    IS_SIGN_IN_WITH_EMAIL_LINK: ("AUTH_IS_SIGN_IN_WITH_EMAIL_LINK" as authType),
    ON_AUTH_STATE_CHANGED: ("AUTH_ON_AUTH_STATE_CHANGED" as authType),
    ON_ID_TOKEN_CHANGED: ("AUTH_ON_ID_TOKEN_CHANGED" as authType),
    SEND_PASSWORD_RESET_EMAIL: ("AUTH_SEND_PASSWORD_RESET_EMAIL" as authType),
    SEND_PASSWORD_RESET_EMAIL_SUCCESS: ("AUTH_SEND_PASSWORD_RESET_EMAIL_SUCCESS" as authType),
    SEND_PASSWORD_RESET_EMAIL_FAILURE: ("AUTH_SEND_PASSWORD_RESET_EMAIL_FAILURE" as authType),
    SEND_SIGN_IN_LINK_TO_EMAIL: ("AUTH_SEND_SIGN_IN_LINK_TO_EMAIL" as authType),
    SEND_SIGN_IN_LINK_TO_EMAIL_SUCCESS: ("AUTH_SEND_SIGN_IN_LINK_TO_EMAIL_SUCCESS" as authType),
    SEND_SIGN_IN_LINK_TO_EMAIL_FAILURE: ("AUTH_SEND_SIGN_IN_LINK_TO_EMAIL_FAILURE" as authType),
    SET_PERSISTENCE: ("AUTH_SET_PERSISTENCE" as authType),
    SET_PERSISTENCE_SUCCESS: ("AUTH_SET_PERSISTENCE_SUCCESS" as authType),
    SET_PERSISTENCE_FAILURE: ("AUTH_SET_PERSISTENCE_FAILURE" as authType),
    SIGN_IN_AND_RETRIEVE_DATA_WITH_CREDENTIAL: ("AUTH_SIGN_IN_AND_RETRIEVE_DATA_WITH_CREDENTIAL" as authType),
    SIGN_IN_AND_RETRIEVE_DATA_WITH_CREDENTIAL_SUCCESS: ("AUTH_SIGN_IN_AND_RETRIEVE_DATA_WITH_CREDENTIAL_SUCCESS" as authType),
    SIGN_IN_AND_RETRIEVE_DATA_WITH_CREDENTIAL_FAILURE: ("AUTH_SIGN_IN_AND_RETRIEVE_DATA_WITH_CREDENTIAL_FAILURE" as authType),
    SIGN_IN_ANONYMOUSLY: ("AUTH_SIGN_IN_ANONYMOUSLY" as authType),
    SIGN_IN_ANONYMOUSLY_SUCCESS: ("AUTH_SIGN_IN_ANONYMOUSLY_SUCCESS" as authType),
    SIGN_IN_ANONYMOUSLY_FAILURE: ("AUTH_SIGN_IN_ANONYMOUSLY_FAILURE" as authType),
    SIGN_IN_WITH_CUSTOM_TOKEN: ("AUTH_SIGN_IN_WITH_CUSTOM_TOKEN" as authType),
    SIGN_IN_WITH_CUSTOM_TOKEN_SUCCESS: ("AUTH_SIGN_IN_WITH_CUSTOM_TOKEN_SUCCESS" as authType),
    SIGN_IN_WITH_CUSTOM_TOKEN_FAILURE: ("AUTH_SIGN_IN_WITH_CUSTOM_TOKEN_FAILURE" as authType),
    SIGN_IN_WITH_EMAIL_AND_PASSWORD: ("AUTH_SIGN_IN_WITH_EMAIL_AND_PASSWORD" as authType),
    SIGN_IN_WITH_EMAIL_AND_PASSWORD_SUCCESS: ("AUTH_SIGN_IN_WITH_EMAIL_AND_PASSWORD_SUCCESS" as authType),
    SIGN_IN_WITH_EMAIL_AND_PASSWORD_FAILURE: ("AUTH_SIGN_IN_WITH_EMAIL_AND_PASSWORD_FAILURE" as authType),
    SIGN_IN_WITH_EMAIL_LINK: ("AUTH_SIGN_IN_WITH_EMAIL_LINK" as authType),
    SIGN_IN_WITH_EMAIL_LINK_SUCCESS: ("AUTH_SIGN_IN_WITH_EMAIL_LINK_SUCCESS" as authType),
    SIGN_IN_WITH_EMAIL_LINK_FAILURE: ("AUTH_SIGN_IN_WITH_EMAIL_LINK_FAILURE" as authType),
    SIGN_IN_WITH_PHONE_NUMBER: ("AUTH_SIGN_IN_WITH_PHONE_NUMBER" as authType),
    SIGN_IN_WITH_PHONE_NUMBER_SUCCESS: ("AUTH_SIGN_IN_WITH_PHONE_NUMBER_SUCCESS" as authType),
    SIGN_IN_WITH_PHONE_NUMBER_FAILURE: ("AUTH_SIGN_IN_WITH_PHONE_NUMBER_FAILURE" as authType),
    SIGN_IN_WITH_POPUP: ("AUTH_SIGN_IN_WITH_POPUP" as authType),
    SIGN_IN_WITH_POPUP_SUCCESS: ("AUTH_SIGN_IN_WITH_POPUP_SUCCESS" as authType),
    SIGN_IN_WITH_POPUP_FAILURE: ("AUTH_SIGN_IN_WITH_POPUP_FAILURE" as authType),
    SIGN_IN_WITH_REDIRECT: ("AUTH_SIGN_IN_WITH_REDIRECT" as authType),
    SIGN_IN_WITH_REDIRECT_SUCCESS: ("AUTH_SIGN_IN_WITH_REDIRECT_SUCCESS" as authType),
    SIGN_IN_WITH_REDIRECT_FAILURE: ("AUTH_SIGN_IN_WITH_REDIRECT_FAILURE" as authType),
    SIGN_OUT: ("AUTH_SIGN_OUT" as authType),
    SIGN_OUT_SUCCESS: ("AUTH_SIGN_OUT_SUCCESS" as authType),
    SIGN_OUT_FAILURE: ("AUTH_SIGN_OUT_FAILURE" as authType),
    UPDATE_CURRENT_USER: ("AUTH_UPDATE_CURRENT_USER" as authType),
    UPDATE_CURRENT_USER_SUCCESS: ("AUTH_UPDATE_CURRENT_USER_SUCCESS" as authType),
    UPDATE_CURRENT_USER_FAILURE: ("AUTH_UPDATE_CURRENT_USER_FAILURE" as authType),
    VERIFY_PASSWORD_RESET_CODE: ("AUTH_VERIFY_PASSWORD_RESET_CODE" as authType),
    VERIFY_PASSWORD_RESET_CODE_SUCCESS: ("AUTH_VERIFY_PASSWORD_RESET_CODE_SUCCESS" as authType),
    VERIFY_PASSWORD_RESET_CODE_FAILURE: ("AUTH_VERIFY_PASSWORD_RESET_CODE_FAILURE" as authType),
    RELOAD: ("AUTH_RELOAD" as authType),
    RELOAD_SUCCESS: ("AUTH_RELOAD_SUCCESS" as authType),
    RELOAD_FAILURE: ("AUTH_RELOAD_FAILURE" as authType),
    INIT: ("AUTH_INIT" as authType),
    DESTROY: ("AUTH_DESTROY" as authType),
    AFTER_INIT: ("AUTH_AFTER_INIT" as authType),
    CLICK_BACK_LINK: ("AUTH_CLICK_BACK_LINK" as authType),
    LOGIN: ("AUTH_LOGIN" as authType),
    LOGIN_SUCCESS: ("AUTH_LOGIN_SUCCESS" as authType),
    LOGIN_FAILURE: ("AUTH_LOGIN_FAILURE" as authType),
    LOGOUT: ("AUTH_LOGOUT" as authType),
    LOGOUT_SUCCESS: ("AUTH_LOGOUT_SUCCESS" as authType),
    LOGOUT_FAILURE: ("AUTH_LOGOUT_FAILURE" as authType),
    FORGOT_PASSWORD: ("AUTH_FORGOT_PASSWORD" as authType),
    FORGOT_PASSWORD_SUCCESS: ("AUTH_FORGOT_PASSWORD_SUCCESS" as authType),
    FORGOT_PASSWORD_FAILURE: ("AUTH_FORGOT_PASSWORD_FAILURE" as authType),
    RESET_PASSWORD_UPDATE: ("AUTH_RESET_PASSWORD_UPDATE" as authType),
    RESET_PASSWORD_UPDATE_SUCCESS: ("AUTH_RESET_PASSWORD_UPDATE_SUCCESS" as authType),
    RESET_PASSWORD_UPDATE_FAILURE: ("AUTH_RESET_PASSWORD_UPDATE_FAILURE" as authType),
    VALIDATE_CODE: ("AUTH_VALIDATE_CODE" as authType),
    VALIDATE_CODE_SUCCESS: ("AUTH_VALIDATE_CODE_SUCCESS" as authType),
    VALIDATE_CODE_FAILURE: ("AUTH_VALIDATE_CODE_FAILURE" as authType),
    REGISTER_EMAIL: ("AUTH_REGISTER_EMAIL" as authType),
    REGISTER_EMAIL_SUCCESS: ("AUTH_REGISTER_EMAIL_SUCCESS" as authType),
    REGISTER_EMAIL_FAILURE: ("AUTH_REGISTER_EMAIL_FAILURE" as authType),
    SEND_EMAIL_VERIFICATION_LINK: ("AUTH_SEND_EMAIL_VERIFICATION_LINK" as authType),
    SEND_EMAIL_VERIFICATION_LINK_SUCCESS: ("AUTH_SEND_EMAIL_VERIFICATION_LINK_SUCCESS" as authType),
    SEND_EMAIL_VERIFICATION_LINK_FAILURE: ("AUTH_SEND_EMAIL_VERIFICATION_LINK_FAILURE" as authType),
    VALIDATE_EMAIL_CODE: ("AUTH_VALIDATE_EMAIL_CODE" as authType),
    VALIDATE_EMAIL_CODE_SUCCESS: ("AUTH_VALIDATE_EMAIL_CODE_SUCCESS" as authType),
    VALIDATE_EMAIL_CODE_FAILURE: ("AUTH_VALIDATE_EMAIL_CODE_FAILURE" as authType),
    STATE_SUCCESS: ("AUTH_STATE_SUCCESS" as authType),
    STATE_FAILURE: ("AUTH_STATE_FAILURE" as authType),
    READY: ("AUTH_READY" as authType),
    UPDATE_PASSWORD: ("AUTH_UPDATE_PASSWORD" as authType),
    UPDATE_PASSWORD_SUCCESS: ("AUTH_UPDATE_PASSWORD_SUCCESS" as authType),
    UPDATE_PASSWORD_FAILURE: ("AUTH_UPDATE_PASSWORD_FAILURE" as authType),
    UPDATE_EMAIL: ("AUTH_UPDATE_EMAIL" as authType),
    UPDATE_EMAIL_SUCCESS: ("AUTH_UPDATE_EMAIL_SUCCESS" as authType),
    UPDATE_EMAIL_FAILURE: ("AUTH_UPDATE_EMAIL_FAILURE" as authType)
};
export type oobType = "INIT" | "DESTROY" | "CLICK_LOGIN";
export const OOB = {
    INIT: ("OOB_INIT" as oobType),
    DESTROY: ("OOB_DESTROY" as oobType),
    CLICK_LOGIN: ("OOB_CLICK_LOGIN" as oobType)
};
export type sessionType = "INIT" | "DESTROY" | "RELOAD" | "RELOAD_SUCCESS" | "RELOAD_FAILURE" | "OOB" | "OOB_RESET_PSSSWORD" | "OOB_RECODER_EMAIL" | "OOB_VERIFY_EMAIL" | "START_SERVICE" | "STOP_SERVICE" | "STATE_CHANGE";
export const SESSION = {
    INIT: ("SESSION_INIT" as sessionType),
    DESTROY: ("SESSION_DESTROY" as sessionType),
    RELOAD: ("SESSION_RELOAD" as sessionType),
    RELOAD_SUCCESS: ("SESSION_RELOAD_SUCCESS" as sessionType),
    RELOAD_FAILURE: ("SESSION_RELOAD_FAILURE" as sessionType),
    OOB: ("SESSION_OOB" as sessionType),
    OOB_RESET_PSSSWORD: ("SESSION_OOB_RESET_PSSSWORD" as sessionType),
    OOB_RECODER_EMAIL: ("SESSION_OOB_RECODER_EMAIL" as sessionType),
    OOB_VERIFY_EMAIL: ("SESSION_OOB_VERIFY_EMAIL" as sessionType),
    START_SERVICE: ("SESSION_START_SERVICE" as sessionType),
    STOP_SERVICE: ("SESSION_STOP_SERVICE" as sessionType),
    STATE_CHANGE: ("SESSION_STATE_CHANGE" as sessionType)
};
export type faqType = "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE" | "INIT" | "DESTROY" | "ON_BLUR_ITEM" | "ON_CLICK_ITEM" | "ON_FOCUS_ITEM";
export const FAQ = {
    HYDRATE: ("FAQ_HYDRATE" as faqType),
    HYDRATE_SUCCESS: ("FAQ_HYDRATE_SUCCESS" as faqType),
    HYDRATE_FAILURE: ("FAQ_HYDRATE_FAILURE" as faqType),
    INIT: ("FAQ_INIT" as faqType),
    DESTROY: ("FAQ_DESTROY" as faqType),
    ON_BLUR_ITEM: ("FAQ_ON_BLUR_ITEM" as faqType),
    ON_CLICK_ITEM: ("FAQ_ON_CLICK_ITEM" as faqType),
    ON_FOCUS_ITEM: ("FAQ_ON_FOCUS_ITEM" as faqType)
};
export type organizationType = "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE";
export const ORGANIZATION = {
    HYDRATE: ("ORGANIZATION_HYDRATE" as organizationType),
    HYDRATE_SUCCESS: ("ORGANIZATION_HYDRATE_SUCCESS" as organizationType),
    HYDRATE_FAILURE: ("ORGANIZATION_HYDRATE_FAILURE" as organizationType)
};
export type sectorsType = "START_SERVICE" | "STOP_SERVICE" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE";
export const SECTORS = {
    START_SERVICE: ("SECTORS_START_SERVICE" as sectorsType),
    STOP_SERVICE: ("SECTORS_STOP_SERVICE" as sectorsType),
    HYDRATE: ("SECTORS_HYDRATE" as sectorsType),
    HYDRATE_SUCCESS: ("SECTORS_HYDRATE_SUCCESS" as sectorsType),
    HYDRATE_FAILURE: ("SECTORS_HYDRATE_FAILURE" as sectorsType)
};
export type contractType = "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE" | "ADD_PARK" | "ADD_PARK_SUCCESS" | "ADD_PARK_FAILURE" | "ADD_SERVICE" | "ADD_SERVICE_SUCCESS" | "ADD_SERVICE_FAILURE" | "ADD_SUBSCRIPTION_SERVICE" | "ADD_SUBSCRIPTION_SERVICE_SUCCESS" | "ADD_SUBSCRIPTION_SERVICE_FAILURE" | "ADD_PAYMENT" | "ADD_PAYMENT_SUCCESS" | "ADD_PAYMENT_FAILURE" | "ACCEPT_CONDITIONS_SERVICE" | "ACCEPT_CONDITIONS_SERVICE_SUCCESS" | "ACCEPT_CONDITIONS_SERVICE_FAILURE" | "ACCEPT_CONDITIONS_PAYMENT" | "ACCEPT_CONDITIONS_PAYMENT_SUCCESS" | "ACCEPT_CONDITIONS_PAYMENT_FAILURE" | "SEARCH" | "SEARCH_SUCCESS" | "SEARCH_FAILURE" | "DELETE" | "DELETE_SUCCESS" | "DELETE_FAILURE" | "CANCEL" | "CANCEL_SUCCESS" | "CANCEL_FAILURE" | "DELETE_SERVICE" | "DELETE_SERVICE_SUCCESS" | "DELETE_SERVICE_FAILURE";
export const CONTRACT = {
    HYDRATE: ("CONTRACT_HYDRATE" as contractType),
    HYDRATE_SUCCESS: ("CONTRACT_HYDRATE_SUCCESS" as contractType),
    HYDRATE_FAILURE: ("CONTRACT_HYDRATE_FAILURE" as contractType),
    ADD_PARK: ("CONTRACT_ADD_PARK" as contractType),
    ADD_PARK_SUCCESS: ("CONTRACT_ADD_PARK_SUCCESS" as contractType),
    ADD_PARK_FAILURE: ("CONTRACT_ADD_PARK_FAILURE" as contractType),
    ADD_SERVICE: ("CONTRACT_ADD_SERVICE" as contractType),
    ADD_SERVICE_SUCCESS: ("CONTRACT_ADD_SERVICE_SUCCESS" as contractType),
    ADD_SERVICE_FAILURE: ("CONTRACT_ADD_SERVICE_FAILURE" as contractType),
    ADD_SUBSCRIPTION_SERVICE: ("CONTRACT_ADD_SUBSCRIPTION_SERVICE" as contractType),
    ADD_SUBSCRIPTION_SERVICE_SUCCESS: ("CONTRACT_ADD_SUBSCRIPTION_SERVICE_SUCCESS" as contractType),
    ADD_SUBSCRIPTION_SERVICE_FAILURE: ("CONTRACT_ADD_SUBSCRIPTION_SERVICE_FAILURE" as contractType),
    ADD_PAYMENT: ("CONTRACT_ADD_PAYMENT" as contractType),
    ADD_PAYMENT_SUCCESS: ("CONTRACT_ADD_PAYMENT_SUCCESS" as contractType),
    ADD_PAYMENT_FAILURE: ("CONTRACT_ADD_PAYMENT_FAILURE" as contractType),
    ACCEPT_CONDITIONS_SERVICE: ("CONTRACT_ACCEPT_CONDITIONS_SERVICE" as contractType),
    ACCEPT_CONDITIONS_SERVICE_SUCCESS: ("CONTRACT_ACCEPT_CONDITIONS_SERVICE_SUCCESS" as contractType),
    ACCEPT_CONDITIONS_SERVICE_FAILURE: ("CONTRACT_ACCEPT_CONDITIONS_SERVICE_FAILURE" as contractType),
    ACCEPT_CONDITIONS_PAYMENT: ("CONTRACT_ACCEPT_CONDITIONS_PAYMENT" as contractType),
    ACCEPT_CONDITIONS_PAYMENT_SUCCESS: ("CONTRACT_ACCEPT_CONDITIONS_PAYMENT_SUCCESS" as contractType),
    ACCEPT_CONDITIONS_PAYMENT_FAILURE: ("CONTRACT_ACCEPT_CONDITIONS_PAYMENT_FAILURE" as contractType),
    SEARCH: ("CONTRACT_SEARCH" as contractType),
    SEARCH_SUCCESS: ("CONTRACT_SEARCH_SUCCESS" as contractType),
    SEARCH_FAILURE: ("CONTRACT_SEARCH_FAILURE" as contractType),
    DELETE: ("CONTRACT_DELETE" as contractType),
    DELETE_SUCCESS: ("CONTRACT_DELETE_SUCCESS" as contractType),
    DELETE_FAILURE: ("CONTRACT_DELETE_FAILURE" as contractType),
    CANCEL: ("CONTRACT_CANCEL" as contractType),
    CANCEL_SUCCESS: ("CONTRACT_CANCEL_SUCCESS" as contractType),
    CANCEL_FAILURE: ("CONTRACT_CANCEL_FAILURE" as contractType),
    DELETE_SERVICE: ("CONTRACT_DELETE_SERVICE" as contractType),
    DELETE_SERVICE_SUCCESS: ("CONTRACT_DELETE_SERVICE_SUCCESS" as contractType),
    DELETE_SERVICE_FAILURE: ("CONTRACT_DELETE_SERVICE_FAILURE" as contractType)
};
export type contractCancelType = "INIT" | "DESTROY" | "CLICK_BACK" | "CLICK_CANCEL" | "SELECT_DATE" | "SELECT_SERVICE";
export const CONTRACT_CANCEL = {
    INIT: ("CONTRACT_CANCEL_INIT" as contractCancelType),
    DESTROY: ("CONTRACT_CANCEL_DESTROY" as contractCancelType),
    CLICK_BACK: ("CONTRACT_CANCEL_CLICK_BACK" as contractCancelType),
    CLICK_CANCEL: ("CONTRACT_CANCEL_CLICK_CANCEL" as contractCancelType),
    SELECT_DATE: ("CONTRACT_CANCEL_SELECT_DATE" as contractCancelType),
    SELECT_SERVICE: ("CONTRACT_CANCEL_SELECT_SERVICE" as contractCancelType)
};
export type contractCreateType = "INIT" | "DESTROY" | "CLICK_NEXT" | "CLICK_PREVIOUS" | "CLICK_FINISH" | "CLICK_ADD_VEHICLE" | "CLICK_MODIFY" | "CLICK_PAYMENT_MODE";
export const CONTRACT_CREATE = {
    INIT: ("CONTRACT_CREATE_INIT" as contractCreateType),
    DESTROY: ("CONTRACT_CREATE_DESTROY" as contractCreateType),
    CLICK_NEXT: ("CONTRACT_CREATE_CLICK_NEXT" as contractCreateType),
    CLICK_PREVIOUS: ("CONTRACT_CREATE_CLICK_PREVIOUS" as contractCreateType),
    CLICK_FINISH: ("CONTRACT_CREATE_CLICK_FINISH" as contractCreateType),
    CLICK_ADD_VEHICLE: ("CONTRACT_CREATE_CLICK_ADD_VEHICLE" as contractCreateType),
    CLICK_MODIFY: ("CONTRACT_CREATE_CLICK_MODIFY" as contractCreateType),
    CLICK_PAYMENT_MODE: ("CONTRACT_CREATE_CLICK_PAYMENT_MODE" as contractCreateType)
};
export type contractDetailsType = "INIT" | "DESTROY" | "CLICK_CANCEL" | "CLICK_PPA_UPDATE" | "CLICK_CC_UPDATE";
export const CONTRACT_DETAILS = {
    INIT: ("CONTRACT_DETAILS_INIT" as contractDetailsType),
    DESTROY: ("CONTRACT_DETAILS_DESTROY" as contractDetailsType),
    CLICK_CANCEL: ("CONTRACT_DETAILS_CLICK_CANCEL" as contractDetailsType),
    CLICK_PPA_UPDATE: ("CONTRACT_DETAILS_CLICK_PPA_UPDATE" as contractDetailsType),
    CLICK_CC_UPDATE: ("CONTRACT_DETAILS_CLICK_CC_UPDATE" as contractDetailsType)
};
export type contractConditionsServiceType = "INIT" | "DESTROY" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE" | "CLICK_ACCEPT";
export const CONTRACT_CONDITIONS_SERVICE = {
    INIT: ("CONTRACT_CONDITIONS_SERVICE_INIT" as contractConditionsServiceType),
    DESTROY: ("CONTRACT_CONDITIONS_SERVICE_DESTROY" as contractConditionsServiceType),
    HYDRATE: ("CONTRACT_CONDITIONS_SERVICE_HYDRATE" as contractConditionsServiceType),
    HYDRATE_SUCCESS: ("CONTRACT_CONDITIONS_SERVICE_HYDRATE_SUCCESS" as contractConditionsServiceType),
    HYDRATE_FAILURE: ("CONTRACT_CONDITIONS_SERVICE_HYDRATE_FAILURE" as contractConditionsServiceType),
    CLICK_ACCEPT: ("CONTRACT_CONDITIONS_SERVICE_CLICK_ACCEPT" as contractConditionsServiceType)
};
export type contractConditionsPaymentType = "INIT" | "DESTROY" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE" | "CLICK_ACCEPT";
export const CONTRACT_CONDITIONS_PAYMENT = {
    INIT: ("CONTRACT_CONDITIONS_PAYMENT_INIT" as contractConditionsPaymentType),
    DESTROY: ("CONTRACT_CONDITIONS_PAYMENT_DESTROY" as contractConditionsPaymentType),
    HYDRATE: ("CONTRACT_CONDITIONS_PAYMENT_HYDRATE" as contractConditionsPaymentType),
    HYDRATE_SUCCESS: ("CONTRACT_CONDITIONS_PAYMENT_HYDRATE_SUCCESS" as contractConditionsPaymentType),
    HYDRATE_FAILURE: ("CONTRACT_CONDITIONS_PAYMENT_HYDRATE_FAILURE" as contractConditionsPaymentType),
    CLICK_ACCEPT: ("CONTRACT_CONDITIONS_PAYMENT_CLICK_ACCEPT" as contractConditionsPaymentType)
};
export type parksType = "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE" | "SELECT";
export const PARKS = {
    HYDRATE: ("PARKS_HYDRATE" as parksType),
    HYDRATE_SUCCESS: ("PARKS_HYDRATE_SUCCESS" as parksType),
    HYDRATE_FAILURE: ("PARKS_HYDRATE_FAILURE" as parksType),
    SELECT: ("PARKS_SELECT" as parksType)
};
export type parksSelectType = "INIT" | "DESTROY" | "CLICK_PARK";
export const PARKS_SELECT = {
    INIT: ("PARKS_SELECT_INIT" as parksSelectType),
    DESTROY: ("PARKS_SELECT_DESTROY" as parksSelectType),
    CLICK_PARK: ("PARKS_SELECT_CLICK_PARK" as parksSelectType)
};
export type calendarType = "DESTROY" | "INIT";
export const CALENDAR = {
    DESTROY: ("CALENDAR_DESTROY" as calendarType),
    INIT: ("CALENDAR_INIT" as calendarType)
};
export type layoutType = "CLICK" | "SET_SCREEN" | "ADD_NODE" | "REMOVE_NODE" | "ADD_GROUP" | "REMOVE_GROUP" | "CLOSE_SIDE_NAV" | "OPEN_SIDE_NAV" | "COLLAPSE_SIDE_NAV" | "CLICK_DELETE_USER" | "INIT_PUBLIC" | "INIT_PRIVATE" | "COLLAPSE_ADMIN_OPTIONS" | "CLICK_ADMIN_MENU" | "CLICK_USER_MENU";
export const LAYOUT = {
    CLICK: ("LAYOUT_CLICK" as layoutType),
    SET_SCREEN: ("LAYOUT_SET_SCREEN" as layoutType),
    ADD_NODE: ("LAYOUT_ADD_NODE" as layoutType),
    REMOVE_NODE: ("LAYOUT_REMOVE_NODE" as layoutType),
    ADD_GROUP: ("LAYOUT_ADD_GROUP" as layoutType),
    REMOVE_GROUP: ("LAYOUT_REMOVE_GROUP" as layoutType),
    CLOSE_SIDE_NAV: ("LAYOUT_CLOSE_SIDE_NAV" as layoutType),
    OPEN_SIDE_NAV: ("LAYOUT_OPEN_SIDE_NAV" as layoutType),
    COLLAPSE_SIDE_NAV: ("LAYOUT_COLLAPSE_SIDE_NAV" as layoutType),
    CLICK_DELETE_USER: ("LAYOUT_CLICK_DELETE_USER" as layoutType),
    INIT_PUBLIC: ("LAYOUT_INIT_PUBLIC" as layoutType),
    INIT_PRIVATE: ("LAYOUT_INIT_PRIVATE" as layoutType),
    COLLAPSE_ADMIN_OPTIONS: ("LAYOUT_COLLAPSE_ADMIN_OPTIONS" as layoutType),
    CLICK_ADMIN_MENU: ("LAYOUT_CLICK_ADMIN_MENU" as layoutType),
    CLICK_USER_MENU: ("LAYOUT_CLICK_USER_MENU" as layoutType)
};
export type profileType = "DESTROY" | "DESTROY_EDIT" | "GO_TO" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE" | "INIT" | "INIT_EDIT" | "SUBMIT_FORM_EDIT" | "SUBMIT_FORM_EDIT_FAILURE" | "UPDATE_FAILURE" | "UPDATE_SUCCESS" | "UPDATE" | "UPDATE_FORM_EDIT";
export const PROFILE = {
    DESTROY: ("PROFILE_DESTROY" as profileType),
    DESTROY_EDIT: ("PROFILE_DESTROY_EDIT" as profileType),
    GO_TO: ("PROFILE_GO_TO" as profileType),
    HYDRATE: ("PROFILE_HYDRATE" as profileType),
    HYDRATE_SUCCESS: ("PROFILE_HYDRATE_SUCCESS" as profileType),
    HYDRATE_FAILURE: ("PROFILE_HYDRATE_FAILURE" as profileType),
    INIT: ("PROFILE_INIT" as profileType),
    INIT_EDIT: ("PROFILE_INIT_EDIT" as profileType),
    SUBMIT_FORM_EDIT: ("PROFILE_SUBMIT_FORM_EDIT" as profileType),
    SUBMIT_FORM_EDIT_FAILURE: ("PROFILE_SUBMIT_FORM_EDIT_FAILURE" as profileType),
    UPDATE_FAILURE: ("PROFILE_UPDATE_FAILURE" as profileType),
    UPDATE_SUCCESS: ("PROFILE_UPDATE_SUCCESS" as profileType),
    UPDATE: ("PROFILE_UPDATE" as profileType),
    UPDATE_FORM_EDIT: ("PROFILE_UPDATE_FORM_EDIT" as profileType)
};
export type profileDetailsType = "DESTROY" | "INIT";
export const PROFILE_DETAILS = {
    DESTROY: ("PROFILE_DETAILS_DESTROY" as profileDetailsType),
    INIT: ("PROFILE_DETAILS_INIT" as profileDetailsType)
};
export type profileEditType = "DESTROY" | "INIT" | "CLICK_SUBMIT" | "FORM_UPDATE";
export const PROFILE_EDIT = {
    DESTROY: ("PROFILE_EDIT_DESTROY" as profileEditType),
    INIT: ("PROFILE_EDIT_INIT" as profileEditType),
    CLICK_SUBMIT: ("PROFILE_EDIT_CLICK_SUBMIT" as profileEditType),
    FORM_UPDATE: ("PROFILE_EDIT_FORM_UPDATE" as profileEditType)
};
export type subscriptionType = "INIT" | "DESTROY" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE";
export const SUBSCRIPTION = {
    INIT: ("SUBSCRIPTION_INIT" as subscriptionType),
    DESTROY: ("SUBSCRIPTION_DESTROY" as subscriptionType),
    HYDRATE: ("SUBSCRIPTION_HYDRATE" as subscriptionType),
    HYDRATE_SUCCESS: ("SUBSCRIPTION_HYDRATE_SUCCESS" as subscriptionType),
    HYDRATE_FAILURE: ("SUBSCRIPTION_HYDRATE_FAILURE" as subscriptionType)
};
export type registerType = "ALREADY_CONFIRMED" | "DESTROY_ACCESS_CODE" | "DESTROY_CONTRACT" | "DESTROY_CONTRACT_CONFIRMATION" | "DESTROY_EMAIL" | "DESTROY_EMAIL_PENDING" | "DESTROY_SUBSCRIPTION" | "GO_TO_SUBSCRIPTION" | "INIT_ACCESS_CODE" | "INIT_CONTRACT" | "INIT_CONTRACT_CONFIRMATION" | "INIT_EMAIL" | "INIT_EMAIL_PENDING" | "INIT_SUBSCRIPTION" | "NOT_LOGGED_IN" | "RECOVER_EMAIL_FAILURE" | "RECOVER_EMAIL_SUCCESS" | "REGISTER_CODE_EMAIL_FAILURE" | "REGISTER_CODE_EMAIL_SUCCESS" | "REGISTER_CODE_SUCCESS" | "REGISTER_CODE_FAILURE" | "REGISTER_CONTRACT_EMAIL_SUCCESS" | "REGISTER_CONTRACT_EMAIL_FAILURE" | "REGISTER_CONTRACT_SUCCESS" | "REGISTER_CONTRACT_FAILURE" | "REGISTER_FAILURE" | "REGISTER_SUCCESS" | "SELECT_METHOD" | "SEND_VALIDATION_LINK_FAILURE" | "SEND_VALIDATION_LINK_SUCCESS" | "SUBMIT_EMAIL_FAILURE" | "VALIDATE_EMAIL_SUCCESS" | "VALIDATE_EMAIL_FAILURE" | "CLICK_BACK_TO_LOGIN" | "CLICK_IGNORE_ACCESS_CODE" | "CLICK_IGNORE_CONTRACT" | "CLICK_IGNORE_SUBSCRIPTION" | "GO_TO_ACCESS_CODE" | "GO_TO_CONTRACT" | "GO_TO_CONTRACT_CONFIRMATION" | "GO_TO_EMAIL" | "GO_TO_EMAIL_PENDING" | "LOGIN" | "LOGOUT" | "RECOVER_EMAIL" | "REGISTER" | "REGISTER_CODE" | "REGISTER_CODE_EMAIL" | "REGISTER_CONTRACT" | "REGISTER_CONTRACT_EMAIL" | "REGISTER_CONTRACT_RESET" | "RESEND" | "SEARCH_CONTRACT" | "SEND_VALIDATION_LINK" | "SUBMIT_EMAIL" | "UPDATE_EMAIL_FORM" | "VALIDATE_EMAIL";
export const REGISTER = {
    ALREADY_CONFIRMED: ("REGISTER_ALREADY_CONFIRMED" as registerType),
    DESTROY_ACCESS_CODE: ("REGISTER_DESTROY_ACCESS_CODE" as registerType),
    DESTROY_CONTRACT: ("REGISTER_DESTROY_CONTRACT" as registerType),
    DESTROY_CONTRACT_CONFIRMATION: ("REGISTER_DESTROY_CONTRACT_CONFIRMATION" as registerType),
    DESTROY_EMAIL: ("REGISTER_DESTROY_EMAIL" as registerType),
    DESTROY_EMAIL_PENDING: ("REGISTER_DESTROY_EMAIL_PENDING" as registerType),
    DESTROY_SUBSCRIPTION: ("REGISTER_DESTROY_SUBSCRIPTION" as registerType),
    GO_TO_SUBSCRIPTION: ("REGISTER_GO_TO_SUBSCRIPTION" as registerType),
    INIT_ACCESS_CODE: ("REGISTER_INIT_ACCESS_CODE" as registerType),
    INIT_CONTRACT: ("REGISTER_INIT_CONTRACT" as registerType),
    INIT_CONTRACT_CONFIRMATION: ("REGISTER_INIT_CONTRACT_CONFIRMATION" as registerType),
    INIT_EMAIL: ("REGISTER_INIT_EMAIL" as registerType),
    INIT_EMAIL_PENDING: ("REGISTER_INIT_EMAIL_PENDING" as registerType),
    INIT_SUBSCRIPTION: ("REGISTER_INIT_SUBSCRIPTION" as registerType),
    NOT_LOGGED_IN: ("REGISTER_NOT_LOGGED_IN" as registerType),
    RECOVER_EMAIL_FAILURE: ("REGISTER_RECOVER_EMAIL_FAILURE" as registerType),
    RECOVER_EMAIL_SUCCESS: ("REGISTER_RECOVER_EMAIL_SUCCESS" as registerType),
    REGISTER_CODE_EMAIL_FAILURE: ("REGISTER_REGISTER_CODE_EMAIL_FAILURE" as registerType),
    REGISTER_CODE_EMAIL_SUCCESS: ("REGISTER_REGISTER_CODE_EMAIL_SUCCESS" as registerType),
    REGISTER_CODE_SUCCESS: ("REGISTER_REGISTER_CODE_SUCCESS" as registerType),
    REGISTER_CODE_FAILURE: ("REGISTER_REGISTER_CODE_FAILURE" as registerType),
    REGISTER_CONTRACT_EMAIL_SUCCESS: ("REGISTER_REGISTER_CONTRACT_EMAIL_SUCCESS" as registerType),
    REGISTER_CONTRACT_EMAIL_FAILURE: ("REGISTER_REGISTER_CONTRACT_EMAIL_FAILURE" as registerType),
    REGISTER_CONTRACT_SUCCESS: ("REGISTER_REGISTER_CONTRACT_SUCCESS" as registerType),
    REGISTER_CONTRACT_FAILURE: ("REGISTER_REGISTER_CONTRACT_FAILURE" as registerType),
    REGISTER_FAILURE: ("REGISTER_REGISTER_FAILURE" as registerType),
    REGISTER_SUCCESS: ("REGISTER_REGISTER_SUCCESS" as registerType),
    SELECT_METHOD: ("REGISTER_SELECT_METHOD" as registerType),
    SEND_VALIDATION_LINK_FAILURE: ("REGISTER_SEND_VALIDATION_LINK_FAILURE" as registerType),
    SEND_VALIDATION_LINK_SUCCESS: ("REGISTER_SEND_VALIDATION_LINK_SUCCESS" as registerType),
    SUBMIT_EMAIL_FAILURE: ("REGISTER_SUBMIT_EMAIL_FAILURE" as registerType),
    VALIDATE_EMAIL_SUCCESS: ("REGISTER_VALIDATE_EMAIL_SUCCESS" as registerType),
    VALIDATE_EMAIL_FAILURE: ("REGISTER_VALIDATE_EMAIL_FAILURE" as registerType),
    CLICK_BACK_TO_LOGIN: ("REGISTER_CLICK_BACK_TO_LOGIN" as registerType),
    CLICK_IGNORE_ACCESS_CODE: ("REGISTER_CLICK_IGNORE_ACCESS_CODE" as registerType),
    CLICK_IGNORE_CONTRACT: ("REGISTER_CLICK_IGNORE_CONTRACT" as registerType),
    CLICK_IGNORE_SUBSCRIPTION: ("REGISTER_CLICK_IGNORE_SUBSCRIPTION" as registerType),
    GO_TO_ACCESS_CODE: ("REGISTER_GO_TO_ACCESS_CODE" as registerType),
    GO_TO_CONTRACT: ("REGISTER_GO_TO_CONTRACT" as registerType),
    GO_TO_CONTRACT_CONFIRMATION: ("REGISTER_GO_TO_CONTRACT_CONFIRMATION" as registerType),
    GO_TO_EMAIL: ("REGISTER_GO_TO_EMAIL" as registerType),
    GO_TO_EMAIL_PENDING: ("REGISTER_GO_TO_EMAIL_PENDING" as registerType),
    LOGIN: ("REGISTER_LOGIN" as registerType),
    LOGOUT: ("REGISTER_LOGOUT" as registerType),
    RECOVER_EMAIL: ("REGISTER_RECOVER_EMAIL" as registerType),
    REGISTER: ("REGISTER_REGISTER" as registerType),
    REGISTER_CODE: ("REGISTER_REGISTER_CODE" as registerType),
    REGISTER_CODE_EMAIL: ("REGISTER_REGISTER_CODE_EMAIL" as registerType),
    REGISTER_CONTRACT: ("REGISTER_REGISTER_CONTRACT" as registerType),
    REGISTER_CONTRACT_EMAIL: ("REGISTER_REGISTER_CONTRACT_EMAIL" as registerType),
    REGISTER_CONTRACT_RESET: ("REGISTER_REGISTER_CONTRACT_RESET" as registerType),
    RESEND: ("REGISTER_RESEND" as registerType),
    SEARCH_CONTRACT: ("REGISTER_SEARCH_CONTRACT" as registerType),
    SEND_VALIDATION_LINK: ("REGISTER_SEND_VALIDATION_LINK" as registerType),
    SUBMIT_EMAIL: ("REGISTER_SUBMIT_EMAIL" as registerType),
    UPDATE_EMAIL_FORM: ("REGISTER_UPDATE_EMAIL_FORM" as registerType),
    VALIDATE_EMAIL: ("REGISTER_VALIDATE_EMAIL" as registerType)
};
export type loginType = "CLICK_SIGNIN" | "CLICK_LOGOUT" | "CLICK_REGISTER" | "CLICK_FORGOT_PASSWORD" | "FORM_UPDATE" | "FORM_RESET" | "INIT" | "DESTROY";
export const LOGIN = {
    CLICK_SIGNIN: ("LOGIN_CLICK_SIGNIN" as loginType),
    CLICK_LOGOUT: ("LOGIN_CLICK_LOGOUT" as loginType),
    CLICK_REGISTER: ("LOGIN_CLICK_REGISTER" as loginType),
    CLICK_FORGOT_PASSWORD: ("LOGIN_CLICK_FORGOT_PASSWORD" as loginType),
    FORM_UPDATE: ("LOGIN_FORM_UPDATE" as loginType),
    FORM_RESET: ("LOGIN_FORM_RESET" as loginType),
    INIT: ("LOGIN_INIT" as loginType),
    DESTROY: ("LOGIN_DESTROY" as loginType)
};
export type metadataType = "HYDRATE" | "HYDRATE_FAILURE" | "HYDRATE_SUCCESS";
export const METADATA = {
    HYDRATE: ("METADATA_HYDRATE" as metadataType),
    HYDRATE_FAILURE: ("METADATA_HYDRATE_FAILURE" as metadataType),
    HYDRATE_SUCCESS: ("METADATA_HYDRATE_SUCCESS" as metadataType)
};
export type contactType = "INIT" | "DESTROY" | "SUBMIT_FORM" | "SUBMIT_FORM_SUCCESS" | "SUBMIT_FORM_FAILURE";
export const CONTACT = {
    INIT: ("CONTACT_INIT" as contactType),
    DESTROY: ("CONTACT_DESTROY" as contactType),
    SUBMIT_FORM: ("CONTACT_SUBMIT_FORM" as contactType),
    SUBMIT_FORM_SUCCESS: ("CONTACT_SUBMIT_FORM_SUCCESS" as contactType),
    SUBMIT_FORM_FAILURE: ("CONTACT_SUBMIT_FORM_FAILURE" as contactType)
};
export type accountStatusType = "HYDRATE" | "HYDRATE_FAILURE" | "HYDRATE_SUCCESS" | "UPDATE";
export const ACCOUNT_STATUS = {
    HYDRATE: ("ACCOUNT_STATUS_HYDRATE" as accountStatusType),
    HYDRATE_FAILURE: ("ACCOUNT_STATUS_HYDRATE_FAILURE" as accountStatusType),
    HYDRATE_SUCCESS: ("ACCOUNT_STATUS_HYDRATE_SUCCESS" as accountStatusType),
    UPDATE: ("ACCOUNT_STATUS_UPDATE" as accountStatusType)
};
export type registerEmailType = "INIT" | "DESTROY" | "CLICK_SUBMIT" | "CLICK_LOGIN" | "CLICK_METHOD" | "COMPLETE" | "FORM_UPDATE" | "FORM_RESET";
export const REGISTER_EMAIL = {
    INIT: ("REGISTER_EMAIL_INIT" as registerEmailType),
    DESTROY: ("REGISTER_EMAIL_DESTROY" as registerEmailType),
    CLICK_SUBMIT: ("REGISTER_EMAIL_CLICK_SUBMIT" as registerEmailType),
    CLICK_LOGIN: ("REGISTER_EMAIL_CLICK_LOGIN" as registerEmailType),
    CLICK_METHOD: ("REGISTER_EMAIL_CLICK_METHOD" as registerEmailType),
    COMPLETE: ("REGISTER_EMAIL_COMPLETE" as registerEmailType),
    FORM_UPDATE: ("REGISTER_EMAIL_FORM_UPDATE" as registerEmailType),
    FORM_RESET: ("REGISTER_EMAIL_FORM_RESET" as registerEmailType)
};
export type subscriptionDetailsType = "INIT" | "DESTROY" | "CLICK_EDIT";
export const SUBSCRIPTION_DETAILS = {
    INIT: ("SUBSCRIPTION_DETAILS_INIT" as subscriptionDetailsType),
    DESTROY: ("SUBSCRIPTION_DETAILS_DESTROY" as subscriptionDetailsType),
    CLICK_EDIT: ("SUBSCRIPTION_DETAILS_CLICK_EDIT" as subscriptionDetailsType)
};
export type subscriptionEditType = "INIT" | "DESTROY" | "UPDATE" | "UPDATE_SUCCESS" | "UPDATE_FAILURE" | "CLICK_SUBMIT" | "FORM_UPDATE" | "FORM_RESET" | "UPLOAD" | "UPLOAD_SUCCESS" | "UPLOAD_FAILURE";
export const SUBSCRIPTION_EDIT = {
    INIT: ("SUBSCRIPTION_EDIT_INIT" as subscriptionEditType),
    DESTROY: ("SUBSCRIPTION_EDIT_DESTROY" as subscriptionEditType),
    UPDATE: ("SUBSCRIPTION_EDIT_UPDATE" as subscriptionEditType),
    UPDATE_SUCCESS: ("SUBSCRIPTION_EDIT_UPDATE_SUCCESS" as subscriptionEditType),
    UPDATE_FAILURE: ("SUBSCRIPTION_EDIT_UPDATE_FAILURE" as subscriptionEditType),
    CLICK_SUBMIT: ("SUBSCRIPTION_EDIT_CLICK_SUBMIT" as subscriptionEditType),
    FORM_UPDATE: ("SUBSCRIPTION_EDIT_FORM_UPDATE" as subscriptionEditType),
    FORM_RESET: ("SUBSCRIPTION_EDIT_FORM_RESET" as subscriptionEditType),
    UPLOAD: ("SUBSCRIPTION_EDIT_UPLOAD" as subscriptionEditType),
    UPLOAD_SUCCESS: ("SUBSCRIPTION_EDIT_UPLOAD_SUCCESS" as subscriptionEditType),
    UPLOAD_FAILURE: ("SUBSCRIPTION_EDIT_UPLOAD_FAILURE" as subscriptionEditType)
};
export type registerSubscriptionType = "INIT" | "DESTROY" | "CLICK_SUBMIT" | "CREATE" | "CREATE_SUCCESS" | "CREATE_FAILURE" | "CLICK_LOGOUT" | "FORM_UPDATE" | "FORM_RESET";
export const REGISTER_SUBSCRIPTION = {
    INIT: ("REGISTER_SUBSCRIPTION_INIT" as registerSubscriptionType),
    DESTROY: ("REGISTER_SUBSCRIPTION_DESTROY" as registerSubscriptionType),
    CLICK_SUBMIT: ("REGISTER_SUBSCRIPTION_CLICK_SUBMIT" as registerSubscriptionType),
    CREATE: ("REGISTER_SUBSCRIPTION_CREATE" as registerSubscriptionType),
    CREATE_SUCCESS: ("REGISTER_SUBSCRIPTION_CREATE_SUCCESS" as registerSubscriptionType),
    CREATE_FAILURE: ("REGISTER_SUBSCRIPTION_CREATE_FAILURE" as registerSubscriptionType),
    CLICK_LOGOUT: ("REGISTER_SUBSCRIPTION_CLICK_LOGOUT" as registerSubscriptionType),
    FORM_UPDATE: ("REGISTER_SUBSCRIPTION_FORM_UPDATE" as registerSubscriptionType),
    FORM_RESET: ("REGISTER_SUBSCRIPTION_FORM_RESET" as registerSubscriptionType)
};
export type registerAccessCodeType = "INIT" | "DESTROY" | "CLICK_SUBMIT" | "CLICK_IGNORE" | "FORM_UPDATE" | "FORM_RESET";
export const REGISTER_ACCESS_CODE = {
    INIT: ("REGISTER_ACCESS_CODE_INIT" as registerAccessCodeType),
    DESTROY: ("REGISTER_ACCESS_CODE_DESTROY" as registerAccessCodeType),
    CLICK_SUBMIT: ("REGISTER_ACCESS_CODE_CLICK_SUBMIT" as registerAccessCodeType),
    CLICK_IGNORE: ("REGISTER_ACCESS_CODE_CLICK_IGNORE" as registerAccessCodeType),
    FORM_UPDATE: ("REGISTER_ACCESS_CODE_FORM_UPDATE" as registerAccessCodeType),
    FORM_RESET: ("REGISTER_ACCESS_CODE_FORM_RESET" as registerAccessCodeType)
};
export type registerContractType = "INIT" | "DESTROY" | "CLICK_SUBMIT" | "CLICK_IGNORE" | "IGNORE_STEP" | "IGNORE_STEP_SUCCESS" | "IGNORE_STEP_FAILURE" | "FORM_UPDATE" | "FORM_RESET";
export const REGISTER_CONTRACT = {
    INIT: ("REGISTER_CONTRACT_INIT" as registerContractType),
    DESTROY: ("REGISTER_CONTRACT_DESTROY" as registerContractType),
    CLICK_SUBMIT: ("REGISTER_CONTRACT_CLICK_SUBMIT" as registerContractType),
    CLICK_IGNORE: ("REGISTER_CONTRACT_CLICK_IGNORE" as registerContractType),
    IGNORE_STEP: ("REGISTER_CONTRACT_IGNORE_STEP" as registerContractType),
    IGNORE_STEP_SUCCESS: ("REGISTER_CONTRACT_IGNORE_STEP_SUCCESS" as registerContractType),
    IGNORE_STEP_FAILURE: ("REGISTER_CONTRACT_IGNORE_STEP_FAILURE" as registerContractType),
    FORM_UPDATE: ("REGISTER_CONTRACT_FORM_UPDATE" as registerContractType),
    FORM_RESET: ("REGISTER_CONTRACT_FORM_RESET" as registerContractType)
};
export type registerPendingType = "INIT" | "DESTROY" | "CLICK_LOGIN" | "CLICK_RESENT" | "CLICK_LOGOUT";
export const REGISTER_PENDING = {
    INIT: ("REGISTER_PENDING_INIT" as registerPendingType),
    DESTROY: ("REGISTER_PENDING_DESTROY" as registerPendingType),
    CLICK_LOGIN: ("REGISTER_PENDING_CLICK_LOGIN" as registerPendingType),
    CLICK_RESENT: ("REGISTER_PENDING_CLICK_RESENT" as registerPendingType),
    CLICK_LOGOUT: ("REGISTER_PENDING_CLICK_LOGOUT" as registerPendingType)
};
export type updatePasswordType = "INIT" | "DESTROY" | "CLICK_SUBMIT" | "CLICK_LOGIN" | "FORM_UPDATE" | "FORM_RESET";
export const UPDATE_PASSWORD = {
    INIT: ("UPDATE_PASSWORD_INIT" as updatePasswordType),
    DESTROY: ("UPDATE_PASSWORD_DESTROY" as updatePasswordType),
    CLICK_SUBMIT: ("UPDATE_PASSWORD_CLICK_SUBMIT" as updatePasswordType),
    CLICK_LOGIN: ("UPDATE_PASSWORD_CLICK_LOGIN" as updatePasswordType),
    FORM_UPDATE: ("UPDATE_PASSWORD_FORM_UPDATE" as updatePasswordType),
    FORM_RESET: ("UPDATE_PASSWORD_FORM_RESET" as updatePasswordType)
};
export type resetPasswordType = "INIT" | "DESTROY" | "CLICK_SUBMIT" | "CLICK_LOGIN" | "FORM_UPDATE" | "FORM_RESET";
export const RESET_PASSWORD = {
    INIT: ("RESET_PASSWORD_INIT" as resetPasswordType),
    DESTROY: ("RESET_PASSWORD_DESTROY" as resetPasswordType),
    CLICK_SUBMIT: ("RESET_PASSWORD_CLICK_SUBMIT" as resetPasswordType),
    CLICK_LOGIN: ("RESET_PASSWORD_CLICK_LOGIN" as resetPasswordType),
    FORM_UPDATE: ("RESET_PASSWORD_FORM_UPDATE" as resetPasswordType),
    FORM_RESET: ("RESET_PASSWORD_FORM_RESET" as resetPasswordType)
};
export type forgotPasswordType = "CLICK_SUBMIT" | "CLICK_LOGIN" | "CLICK_RESEND_EMAIL" | "FORM_UPDATE" | "FORM_RESET" | "INIT" | "INIT_CONFIRMATION" | "DESTROY_CONFIRMATION" | "DESTROY";
export const FORGOT_PASSWORD = {
    CLICK_SUBMIT: ("FORGOT_PASSWORD_CLICK_SUBMIT" as forgotPasswordType),
    CLICK_LOGIN: ("FORGOT_PASSWORD_CLICK_LOGIN" as forgotPasswordType),
    CLICK_RESEND_EMAIL: ("FORGOT_PASSWORD_CLICK_RESEND_EMAIL" as forgotPasswordType),
    FORM_UPDATE: ("FORGOT_PASSWORD_FORM_UPDATE" as forgotPasswordType),
    FORM_RESET: ("FORGOT_PASSWORD_FORM_RESET" as forgotPasswordType),
    INIT: ("FORGOT_PASSWORD_INIT" as forgotPasswordType),
    INIT_CONFIRMATION: ("FORGOT_PASSWORD_INIT_CONFIRMATION" as forgotPasswordType),
    DESTROY_CONFIRMATION: ("FORGOT_PASSWORD_DESTROY_CONFIRMATION" as forgotPasswordType),
    DESTROY: ("FORGOT_PASSWORD_DESTROY" as forgotPasswordType)
};
export type userType = "START_SERVICE" | "STOP_SERVICE" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE" | "DELETE_USER" | "DELETE_USER_SUCCESS" | "DELETE_USER_FAILURE" | "SYNC" | "SYNC_SUCCESS" | "SYNC_FAILURE";
export const USER = {
    START_SERVICE: ("USER_START_SERVICE" as userType),
    STOP_SERVICE: ("USER_STOP_SERVICE" as userType),
    HYDRATE: ("USER_HYDRATE" as userType),
    HYDRATE_SUCCESS: ("USER_HYDRATE_SUCCESS" as userType),
    HYDRATE_FAILURE: ("USER_HYDRATE_FAILURE" as userType),
    DELETE_USER: ("USER_DELETE_USER" as userType),
    DELETE_USER_SUCCESS: ("USER_DELETE_USER_SUCCESS" as userType),
    DELETE_USER_FAILURE: ("USER_DELETE_USER_FAILURE" as userType),
    SYNC: ("USER_SYNC" as userType),
    SYNC_SUCCESS: ("USER_SYNC_SUCCESS" as userType),
    SYNC_FAILURE: ("USER_SYNC_FAILURE" as userType)
};
export type userVehiclesType = "START_SERVICE" | "STOP_SERVICE" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE" | "DELETE" | "DELETE_SUCCESS" | "DELETE_FAILURE";
export const USER_VEHICLES = {
    START_SERVICE: ("USER_VEHICLES_START_SERVICE" as userVehiclesType),
    STOP_SERVICE: ("USER_VEHICLES_STOP_SERVICE" as userVehiclesType),
    HYDRATE: ("USER_VEHICLES_HYDRATE" as userVehiclesType),
    HYDRATE_SUCCESS: ("USER_VEHICLES_HYDRATE_SUCCESS" as userVehiclesType),
    HYDRATE_FAILURE: ("USER_VEHICLES_HYDRATE_FAILURE" as userVehiclesType),
    DELETE: ("USER_VEHICLES_DELETE" as userVehiclesType),
    DELETE_SUCCESS: ("USER_VEHICLES_DELETE_SUCCESS" as userVehiclesType),
    DELETE_FAILURE: ("USER_VEHICLES_DELETE_FAILURE" as userVehiclesType)
};
export type userVehiclesDetailsType = "INIT" | "DESTROY" | "CLICK_DELETE" | "CLICK_ADD" | "CLICK_EDIT";
export const USER_VEHICLES_DETAILS = {
    INIT: ("USER_VEHICLES_DETAILS_INIT" as userVehiclesDetailsType),
    DESTROY: ("USER_VEHICLES_DETAILS_DESTROY" as userVehiclesDetailsType),
    CLICK_DELETE: ("USER_VEHICLES_DETAILS_CLICK_DELETE" as userVehiclesDetailsType),
    CLICK_ADD: ("USER_VEHICLES_DETAILS_CLICK_ADD" as userVehiclesDetailsType),
    CLICK_EDIT: ("USER_VEHICLES_DETAILS_CLICK_EDIT" as userVehiclesDetailsType)
};
export type vehiclesFormType = "INIT" | "DESTROY" | "SELECT_YEAR" | "SELECT_BRAND" | "VALIDATION_REQUIRED" | "CLICK_VALIDATION";
export const VEHICLES_FORM = {
    INIT: ("VEHICLES_FORM_INIT" as vehiclesFormType),
    DESTROY: ("VEHICLES_FORM_DESTROY" as vehiclesFormType),
    SELECT_YEAR: ("VEHICLES_FORM_SELECT_YEAR" as vehiclesFormType),
    SELECT_BRAND: ("VEHICLES_FORM_SELECT_BRAND" as vehiclesFormType),
    VALIDATION_REQUIRED: ("VEHICLES_FORM_VALIDATION_REQUIRED" as vehiclesFormType),
    CLICK_VALIDATION: ("VEHICLES_FORM_CLICK_VALIDATION" as vehiclesFormType)
};
export type vehiclesType = "INIT" | "DESTROY" | "FORM_HYDRATE" | "FORM_HYDRATE_SUCCESS" | "FORM_HYDRATE_FAILURE" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE" | "HYDRATE_BRANDS_SUCCESS" | "HYDRATE_BRANDS_FAILURE" | "HYDRATE_MODELS_SUCCESS" | "HYDRATE_MODELS_FAILURE" | "SELECT_YEAR" | "SELECT_BRAND";
export const VEHICLES = {
    INIT: ("VEHICLES_INIT" as vehiclesType),
    DESTROY: ("VEHICLES_DESTROY" as vehiclesType),
    FORM_HYDRATE: ("VEHICLES_FORM_HYDRATE" as vehiclesType),
    FORM_HYDRATE_SUCCESS: ("VEHICLES_FORM_HYDRATE_SUCCESS" as vehiclesType),
    FORM_HYDRATE_FAILURE: ("VEHICLES_FORM_HYDRATE_FAILURE" as vehiclesType),
    HYDRATE: ("VEHICLES_HYDRATE" as vehiclesType),
    HYDRATE_SUCCESS: ("VEHICLES_HYDRATE_SUCCESS" as vehiclesType),
    HYDRATE_FAILURE: ("VEHICLES_HYDRATE_FAILURE" as vehiclesType),
    HYDRATE_BRANDS_SUCCESS: ("VEHICLES_HYDRATE_BRANDS_SUCCESS" as vehiclesType),
    HYDRATE_BRANDS_FAILURE: ("VEHICLES_HYDRATE_BRANDS_FAILURE" as vehiclesType),
    HYDRATE_MODELS_SUCCESS: ("VEHICLES_HYDRATE_MODELS_SUCCESS" as vehiclesType),
    HYDRATE_MODELS_FAILURE: ("VEHICLES_HYDRATE_MODELS_FAILURE" as vehiclesType),
    SELECT_YEAR: ("VEHICLES_SELECT_YEAR" as vehiclesType),
    SELECT_BRAND: ("VEHICLES_SELECT_BRAND" as vehiclesType)
};
export type vehiclesDetailsType = "INIT" | "DESTROY" | "CLICK_ADD" | "CLICK_EDIT" | "CLICK_DELETE";
export const VEHICLES_DETAILS = {
    INIT: ("VEHICLES_DETAILS_INIT" as vehiclesDetailsType),
    DESTROY: ("VEHICLES_DETAILS_DESTROY" as vehiclesDetailsType),
    CLICK_ADD: ("VEHICLES_DETAILS_CLICK_ADD" as vehiclesDetailsType),
    CLICK_EDIT: ("VEHICLES_DETAILS_CLICK_EDIT" as vehiclesDetailsType),
    CLICK_DELETE: ("VEHICLES_DETAILS_CLICK_DELETE" as vehiclesDetailsType)
};
export type vehiclesAddType = "INIT" | "DESTROY" | "FORM_UPDATE" | "SELECT_YEAR" | "SELECT_BRAND" | "SELECT_MODEL" | "CLICK_SUBMIT" | "ADD" | "ADD_SUCCESS" | "ADD_FAILURE" | "UPDATE" | "UPDATE_SUCCESS" | "UPDATE_FAILURE" | "VALIDATION_REQUIRED";
export const VEHICLES_ADD = {
    INIT: ("VEHICLES_ADD_INIT" as vehiclesAddType),
    DESTROY: ("VEHICLES_ADD_DESTROY" as vehiclesAddType),
    FORM_UPDATE: ("VEHICLES_ADD_FORM_UPDATE" as vehiclesAddType),
    SELECT_YEAR: ("VEHICLES_ADD_SELECT_YEAR" as vehiclesAddType),
    SELECT_BRAND: ("VEHICLES_ADD_SELECT_BRAND" as vehiclesAddType),
    SELECT_MODEL: ("VEHICLES_ADD_SELECT_MODEL" as vehiclesAddType),
    CLICK_SUBMIT: ("VEHICLES_ADD_CLICK_SUBMIT" as vehiclesAddType),
    ADD: ("VEHICLES_ADD_ADD" as vehiclesAddType),
    ADD_SUCCESS: ("VEHICLES_ADD_ADD_SUCCESS" as vehiclesAddType),
    ADD_FAILURE: ("VEHICLES_ADD_ADD_FAILURE" as vehiclesAddType),
    UPDATE: ("VEHICLES_ADD_UPDATE" as vehiclesAddType),
    UPDATE_SUCCESS: ("VEHICLES_ADD_UPDATE_SUCCESS" as vehiclesAddType),
    UPDATE_FAILURE: ("VEHICLES_ADD_UPDATE_FAILURE" as vehiclesAddType),
    VALIDATION_REQUIRED: ("VEHICLES_ADD_VALIDATION_REQUIRED" as vehiclesAddType)
};
export type vehiclesEditType = "INIT" | "DESTROY" | "FORM_UPDATE" | "SELECT_YEAR" | "SELECT_BRAND" | "SELECT_MODEL" | "CLICK_SUBMIT" | "UPDATE" | "UPDATE_SUCCESS" | "UPDATE_FAILURE";
export const VEHICLES_EDIT = {
    INIT: ("VEHICLES_EDIT_INIT" as vehiclesEditType),
    DESTROY: ("VEHICLES_EDIT_DESTROY" as vehiclesEditType),
    FORM_UPDATE: ("VEHICLES_EDIT_FORM_UPDATE" as vehiclesEditType),
    SELECT_YEAR: ("VEHICLES_EDIT_SELECT_YEAR" as vehiclesEditType),
    SELECT_BRAND: ("VEHICLES_EDIT_SELECT_BRAND" as vehiclesEditType),
    SELECT_MODEL: ("VEHICLES_EDIT_SELECT_MODEL" as vehiclesEditType),
    CLICK_SUBMIT: ("VEHICLES_EDIT_CLICK_SUBMIT" as vehiclesEditType),
    UPDATE: ("VEHICLES_EDIT_UPDATE" as vehiclesEditType),
    UPDATE_SUCCESS: ("VEHICLES_EDIT_UPDATE_SUCCESS" as vehiclesEditType),
    UPDATE_FAILURE: ("VEHICLES_EDIT_UPDATE_FAILURE" as vehiclesEditType)
};
export type settingsType = "INIT" | "DESTROY" | "CLICK";
export const SETTINGS = {
    INIT: ("SETTINGS_INIT" as settingsType),
    DESTROY: ("SETTINGS_DESTROY" as settingsType),
    CLICK: ("SETTINGS_CLICK" as settingsType)
};
export type servicesType = "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE";
export const SERVICES = {
    HYDRATE: ("SERVICES_HYDRATE" as servicesType),
    HYDRATE_SUCCESS: ("SERVICES_HYDRATE_SUCCESS" as servicesType),
    HYDRATE_FAILURE: ("SERVICES_HYDRATE_FAILURE" as servicesType)
};
export type paymentSelectMethodType = "INIT" | "DESTROY" | "SELECT_METHOD";
export const PAYMENT_SELECT_METHOD = {
    INIT: ("PAYMENT_SELECT_METHOD_INIT" as paymentSelectMethodType),
    DESTROY: ("PAYMENT_SELECT_METHOD_DESTROY" as paymentSelectMethodType),
    SELECT_METHOD: ("PAYMENT_SELECT_METHOD_SELECT_METHOD" as paymentSelectMethodType)
};
export type servicesSelectType = "INIT" | "DESTROY" | "CLICK_SERVICE";
export const SERVICES_SELECT = {
    INIT: ("SERVICES_SELECT_INIT" as servicesSelectType),
    DESTROY: ("SERVICES_SELECT_DESTROY" as servicesSelectType),
    CLICK_SERVICE: ("SERVICES_SELECT_CLICK_SERVICE" as servicesSelectType)
};
export type accessCodeType = "INIT" | "DESTROY" | "HYDRATE" | "HYDRATE_FAILURE" | "HYDRATE_SUCCESS" | "ADD" | "DELETE" | "ADD_SUCCESS" | "ADD_FAILURE";
export const ACCESS_CODE = {
    INIT: ("ACCESS_CODE_INIT" as accessCodeType),
    DESTROY: ("ACCESS_CODE_DESTROY" as accessCodeType),
    HYDRATE: ("ACCESS_CODE_HYDRATE" as accessCodeType),
    HYDRATE_FAILURE: ("ACCESS_CODE_HYDRATE_FAILURE" as accessCodeType),
    HYDRATE_SUCCESS: ("ACCESS_CODE_HYDRATE_SUCCESS" as accessCodeType),
    ADD: ("ACCESS_CODE_ADD" as accessCodeType),
    DELETE: ("ACCESS_CODE_DELETE" as accessCodeType),
    ADD_SUCCESS: ("ACCESS_CODE_ADD_SUCCESS" as accessCodeType),
    ADD_FAILURE: ("ACCESS_CODE_ADD_FAILURE" as accessCodeType)
};
export type contractSearchType = "INIT" | "DESTROY" | "FORM_UPDATE";
export const CONTRACT_SEARCH = {
    INIT: ("CONTRACT_SEARCH_INIT" as contractSearchType),
    DESTROY: ("CONTRACT_SEARCH_DESTROY" as contractSearchType),
    FORM_UPDATE: ("CONTRACT_SEARCH_FORM_UPDATE" as contractSearchType)
};
export type accessCodeDetailsType = "INIT" | "DESTROY" | "CLICK_ADD_ACCESS_CODE";
export const ACCESS_CODE_DETAILS = {
    INIT: ("ACCESS_CODE_DETAILS_INIT" as accessCodeDetailsType),
    DESTROY: ("ACCESS_CODE_DETAILS_DESTROY" as accessCodeDetailsType),
    CLICK_ADD_ACCESS_CODE: ("ACCESS_CODE_DETAILS_CLICK_ADD_ACCESS_CODE" as accessCodeDetailsType)
};
export type accessCodeAddType = "INIT" | "DESTROY" | "FORM_UPDATE" | "SUBMIT";
export const ACCESS_CODE_ADD = {
    INIT: ("ACCESS_CODE_ADD_INIT" as accessCodeAddType),
    DESTROY: ("ACCESS_CODE_ADD_DESTROY" as accessCodeAddType),
    FORM_UPDATE: ("ACCESS_CODE_ADD_FORM_UPDATE" as accessCodeAddType),
    SUBMIT: ("ACCESS_CODE_ADD_SUBMIT" as accessCodeAddType)
};
export type adminConfigurationType = "INIT" | "DESTROY" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE" | "UPDATE_MONERIS" | "UPDATE_MONERIS_SUCCESS" | "UPDATE_MONERIS_FAILURE";
export const ADMIN_CONFIGURATION = {
    INIT: ("ADMIN_CONFIGURATION_INIT" as adminConfigurationType),
    DESTROY: ("ADMIN_CONFIGURATION_DESTROY" as adminConfigurationType),
    HYDRATE: ("ADMIN_CONFIGURATION_HYDRATE" as adminConfigurationType),
    HYDRATE_SUCCESS: ("ADMIN_CONFIGURATION_HYDRATE_SUCCESS" as adminConfigurationType),
    HYDRATE_FAILURE: ("ADMIN_CONFIGURATION_HYDRATE_FAILURE" as adminConfigurationType),
    UPDATE_MONERIS: ("ADMIN_CONFIGURATION_UPDATE_MONERIS" as adminConfigurationType),
    UPDATE_MONERIS_SUCCESS: ("ADMIN_CONFIGURATION_UPDATE_MONERIS_SUCCESS" as adminConfigurationType),
    UPDATE_MONERIS_FAILURE: ("ADMIN_CONFIGURATION_UPDATE_MONERIS_FAILURE" as adminConfigurationType)
};
export type adminProfileType = "INIT" | "DESTROY" | "CLICK_SYNC" | "CLICK_NEW_CONTRACT" | "CLICK_NEW_ACCESS_CODE" | "CLICK_NEW_ACCOUNT";
export const ADMIN_PROFILE = {
    INIT: ("ADMIN_PROFILE_INIT" as adminProfileType),
    DESTROY: ("ADMIN_PROFILE_DESTROY" as adminProfileType),
    CLICK_SYNC: ("ADMIN_PROFILE_CLICK_SYNC" as adminProfileType),
    CLICK_NEW_CONTRACT: ("ADMIN_PROFILE_CLICK_NEW_CONTRACT" as adminProfileType),
    CLICK_NEW_ACCESS_CODE: ("ADMIN_PROFILE_CLICK_NEW_ACCESS_CODE" as adminProfileType),
    CLICK_NEW_ACCOUNT: ("ADMIN_PROFILE_CLICK_NEW_ACCOUNT" as adminProfileType)
};
export type adminLogsType = "INIT" | "DESTROY";
export const ADMIN_LOGS = {
    INIT: ("ADMIN_LOGS_INIT" as adminLogsType),
    DESTROY: ("ADMIN_LOGS_DESTROY" as adminLogsType)
};
export type adminMailsType = "INIT" | "DESTROY";
export const ADMIN_MAILS = {
    INIT: ("ADMIN_MAILS_INIT" as adminMailsType),
    DESTROY: ("ADMIN_MAILS_DESTROY" as adminMailsType)
};
export type adminOrganizationFormType = "INIT" | "DESTROY" | "CLICK_SUBMIT" | "UPDATE" | "UPDATE_SUCCESS" | "UPDATE_FAILURE" | "ADD" | "ADD_SUCCESS" | "ADD_FAILURE" | "UPLOAD" | "UPLOAD_SUCCESS" | "UPLOAD_FAILURE";
export const ADMIN_ORGANIZATION_FORM = {
    INIT: ("ADMIN_ORGANIZATION_FORM_INIT" as adminOrganizationFormType),
    DESTROY: ("ADMIN_ORGANIZATION_FORM_DESTROY" as adminOrganizationFormType),
    CLICK_SUBMIT: ("ADMIN_ORGANIZATION_FORM_CLICK_SUBMIT" as adminOrganizationFormType),
    UPDATE: ("ADMIN_ORGANIZATION_FORM_UPDATE" as adminOrganizationFormType),
    UPDATE_SUCCESS: ("ADMIN_ORGANIZATION_FORM_UPDATE_SUCCESS" as adminOrganizationFormType),
    UPDATE_FAILURE: ("ADMIN_ORGANIZATION_FORM_UPDATE_FAILURE" as adminOrganizationFormType),
    ADD: ("ADMIN_ORGANIZATION_FORM_ADD" as adminOrganizationFormType),
    ADD_SUCCESS: ("ADMIN_ORGANIZATION_FORM_ADD_SUCCESS" as adminOrganizationFormType),
    ADD_FAILURE: ("ADMIN_ORGANIZATION_FORM_ADD_FAILURE" as adminOrganizationFormType),
    UPLOAD: ("ADMIN_ORGANIZATION_FORM_UPLOAD" as adminOrganizationFormType),
    UPLOAD_SUCCESS: ("ADMIN_ORGANIZATION_FORM_UPLOAD_SUCCESS" as adminOrganizationFormType),
    UPLOAD_FAILURE: ("ADMIN_ORGANIZATION_FORM_UPLOAD_FAILURE" as adminOrganizationFormType)
};
export type testType = "INIT" | "DESTROY" | "SHOW_PAGE";
export const TEST = {
    INIT: ("TEST_INIT" as testType),
    DESTROY: ("TEST_DESTROY" as testType),
    SHOW_PAGE: ("TEST_SHOW_PAGE" as testType)
};
export type testGroupFormType = "INIT" | "DESTROY" | "CLICK_SUBMIT" | "UPDATE" | "UPDATE_SUCCESS" | "UPDATE_FAILURE" | "ADD" | "ADD_SUCCESS" | "ADD_FAILURE";
export const TEST_GROUP_FORM = {
    INIT: ("TEST_GROUP_FORM_INIT" as testGroupFormType),
    DESTROY: ("TEST_GROUP_FORM_DESTROY" as testGroupFormType),
    CLICK_SUBMIT: ("TEST_GROUP_FORM_CLICK_SUBMIT" as testGroupFormType),
    UPDATE: ("TEST_GROUP_FORM_UPDATE" as testGroupFormType),
    UPDATE_SUCCESS: ("TEST_GROUP_FORM_UPDATE_SUCCESS" as testGroupFormType),
    UPDATE_FAILURE: ("TEST_GROUP_FORM_UPDATE_FAILURE" as testGroupFormType),
    ADD: ("TEST_GROUP_FORM_ADD" as testGroupFormType),
    ADD_SUCCESS: ("TEST_GROUP_FORM_ADD_SUCCESS" as testGroupFormType),
    ADD_FAILURE: ("TEST_GROUP_FORM_ADD_FAILURE" as testGroupFormType)
};
export type testListType = "INIT" | "DESTROY" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE" | "SELECT" | "DELETE" | "DELETE_SUCCESS" | "DELETE_FAILURE" | "CLICK_ADD" | "CLICK_EDIT" | "CLICK_DELETE";
export const TEST_LIST = {
    INIT: ("TEST_LIST_INIT" as testListType),
    DESTROY: ("TEST_LIST_DESTROY" as testListType),
    HYDRATE: ("TEST_LIST_HYDRATE" as testListType),
    HYDRATE_SUCCESS: ("TEST_LIST_HYDRATE_SUCCESS" as testListType),
    HYDRATE_FAILURE: ("TEST_LIST_HYDRATE_FAILURE" as testListType),
    SELECT: ("TEST_LIST_SELECT" as testListType),
    DELETE: ("TEST_LIST_DELETE" as testListType),
    DELETE_SUCCESS: ("TEST_LIST_DELETE_SUCCESS" as testListType),
    DELETE_FAILURE: ("TEST_LIST_DELETE_FAILURE" as testListType),
    CLICK_ADD: ("TEST_LIST_CLICK_ADD" as testListType),
    CLICK_EDIT: ("TEST_LIST_CLICK_EDIT" as testListType),
    CLICK_DELETE: ("TEST_LIST_CLICK_DELETE" as testListType)
};
export type testFormType = "INIT" | "DESTROY" | "CLICK_SUBMIT" | "UPDATE" | "UPDATE_SUCCESS" | "UPDATE_FAILURE" | "ADD" | "ADD_SUCCESS" | "ADD_FAILURE" | "FORM_UPDATE";
export const TEST_FORM = {
    INIT: ("TEST_FORM_INIT" as testFormType),
    DESTROY: ("TEST_FORM_DESTROY" as testFormType),
    CLICK_SUBMIT: ("TEST_FORM_CLICK_SUBMIT" as testFormType),
    UPDATE: ("TEST_FORM_UPDATE" as testFormType),
    UPDATE_SUCCESS: ("TEST_FORM_UPDATE_SUCCESS" as testFormType),
    UPDATE_FAILURE: ("TEST_FORM_UPDATE_FAILURE" as testFormType),
    ADD: ("TEST_FORM_ADD" as testFormType),
    ADD_SUCCESS: ("TEST_FORM_ADD_SUCCESS" as testFormType),
    ADD_FAILURE: ("TEST_FORM_ADD_FAILURE" as testFormType),
    FORM_UPDATE: ("TEST_FORM_FORM_UPDATE" as testFormType)
};
export type testGroupListType = "INIT" | "DESTROY" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE" | "SELECT" | "DELETE" | "DELETE_SUCCESS" | "DELETE_FAILURE" | "CLICK_ADD" | "CLICK_EDIT" | "CLICK_DELETE";
export const TEST_GROUP_LIST = {
    INIT: ("TEST_GROUP_LIST_INIT" as testGroupListType),
    DESTROY: ("TEST_GROUP_LIST_DESTROY" as testGroupListType),
    HYDRATE: ("TEST_GROUP_LIST_HYDRATE" as testGroupListType),
    HYDRATE_SUCCESS: ("TEST_GROUP_LIST_HYDRATE_SUCCESS" as testGroupListType),
    HYDRATE_FAILURE: ("TEST_GROUP_LIST_HYDRATE_FAILURE" as testGroupListType),
    SELECT: ("TEST_GROUP_LIST_SELECT" as testGroupListType),
    DELETE: ("TEST_GROUP_LIST_DELETE" as testGroupListType),
    DELETE_SUCCESS: ("TEST_GROUP_LIST_DELETE_SUCCESS" as testGroupListType),
    DELETE_FAILURE: ("TEST_GROUP_LIST_DELETE_FAILURE" as testGroupListType),
    CLICK_ADD: ("TEST_GROUP_LIST_CLICK_ADD" as testGroupListType),
    CLICK_EDIT: ("TEST_GROUP_LIST_CLICK_EDIT" as testGroupListType),
    CLICK_DELETE: ("TEST_GROUP_LIST_CLICK_DELETE" as testGroupListType)
};
export type adminType = "INIT" | "DESTROY" | "SHOW_PAGE";
export const ADMIN = {
    INIT: ("ADMIN_INIT" as adminType),
    DESTROY: ("ADMIN_DESTROY" as adminType),
    SHOW_PAGE: ("ADMIN_SHOW_PAGE" as adminType)
};
export type adminOrganizationListType = "INIT" | "DESTROY" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE" | "DELETE" | "DELETE_SUCCESS" | "DELETE_FAILURE" | "CLICK_ADD" | "CLICK_EDIT" | "CLICK_DELETE" | "SELECT" | "SHOW_GROUPS" | "SHOW_CODES";
export const ADMIN_ORGANIZATION_LIST = {
    INIT: ("ADMIN_ORGANIZATION_LIST_INIT" as adminOrganizationListType),
    DESTROY: ("ADMIN_ORGANIZATION_LIST_DESTROY" as adminOrganizationListType),
    HYDRATE: ("ADMIN_ORGANIZATION_LIST_HYDRATE" as adminOrganizationListType),
    HYDRATE_SUCCESS: ("ADMIN_ORGANIZATION_LIST_HYDRATE_SUCCESS" as adminOrganizationListType),
    HYDRATE_FAILURE: ("ADMIN_ORGANIZATION_LIST_HYDRATE_FAILURE" as adminOrganizationListType),
    DELETE: ("ADMIN_ORGANIZATION_LIST_DELETE" as adminOrganizationListType),
    DELETE_SUCCESS: ("ADMIN_ORGANIZATION_LIST_DELETE_SUCCESS" as adminOrganizationListType),
    DELETE_FAILURE: ("ADMIN_ORGANIZATION_LIST_DELETE_FAILURE" as adminOrganizationListType),
    CLICK_ADD: ("ADMIN_ORGANIZATION_LIST_CLICK_ADD" as adminOrganizationListType),
    CLICK_EDIT: ("ADMIN_ORGANIZATION_LIST_CLICK_EDIT" as adminOrganizationListType),
    CLICK_DELETE: ("ADMIN_ORGANIZATION_LIST_CLICK_DELETE" as adminOrganizationListType),
    SELECT: ("ADMIN_ORGANIZATION_LIST_SELECT" as adminOrganizationListType),
    SHOW_GROUPS: ("ADMIN_ORGANIZATION_LIST_SHOW_GROUPS" as adminOrganizationListType),
    SHOW_CODES: ("ADMIN_ORGANIZATION_LIST_SHOW_CODES" as adminOrganizationListType)
};
export type adminGroupFormType = "INIT" | "DESTROY" | "CLICK_ADD_ORGANIZATION" | "CLICK_SUBMIT" | "UPDATE" | "UPDATE_SUCCESS" | "UPDATE_FAILURE" | "ADD" | "ADD_SUCCESS" | "ADD_FAILURE";
export const ADMIN_GROUP_FORM = {
    INIT: ("ADMIN_GROUP_FORM_INIT" as adminGroupFormType),
    DESTROY: ("ADMIN_GROUP_FORM_DESTROY" as adminGroupFormType),
    CLICK_ADD_ORGANIZATION: ("ADMIN_GROUP_FORM_CLICK_ADD_ORGANIZATION" as adminGroupFormType),
    CLICK_SUBMIT: ("ADMIN_GROUP_FORM_CLICK_SUBMIT" as adminGroupFormType),
    UPDATE: ("ADMIN_GROUP_FORM_UPDATE" as adminGroupFormType),
    UPDATE_SUCCESS: ("ADMIN_GROUP_FORM_UPDATE_SUCCESS" as adminGroupFormType),
    UPDATE_FAILURE: ("ADMIN_GROUP_FORM_UPDATE_FAILURE" as adminGroupFormType),
    ADD: ("ADMIN_GROUP_FORM_ADD" as adminGroupFormType),
    ADD_SUCCESS: ("ADMIN_GROUP_FORM_ADD_SUCCESS" as adminGroupFormType),
    ADD_FAILURE: ("ADMIN_GROUP_FORM_ADD_FAILURE" as adminGroupFormType)
};
export type adminGroupMetasType = "INIT" | "DESTROY" | "UPDATE_CONDITIONS_SERVICES" | "UPDATE_CONDITIONS_CC" | "UPDATE_CONDITIONS_DAS" | "UPDATE_CONDITIONS_PPA" | "UPDATE_CONDITIONS_INTERNET" | "UPDATE_CONDITIONS_SERVICES_SUCCESS" | "UPDATE_CONDITIONS_CC_SUCCESS" | "UPDATE_CONDITIONS_DAS_SUCCESS" | "UPDATE_CONDITIONS_PPA_SUCCESS" | "UPDATE_CONDITIONS_INTERNET_SUCCESS" | "UPDATE_CONDITIONS_SERVICES_FAILURE" | "UPDATE_CONDITIONS_CC_FAILURE" | "UPDATE_CONDITIONS_DAS_FAILURE" | "UPDATE_CONDITIONS_PPA_FAILURE" | "UPDATE_CONDITIONS_INTERNET_FAILURE";
export const ADMIN_GROUP_METAS = {
    INIT: ("ADMIN_GROUP_METAS_INIT" as adminGroupMetasType),
    DESTROY: ("ADMIN_GROUP_METAS_DESTROY" as adminGroupMetasType),
    UPDATE_CONDITIONS_SERVICES: ("ADMIN_GROUP_METAS_UPDATE_CONDITIONS_SERVICES" as adminGroupMetasType),
    UPDATE_CONDITIONS_CC: ("ADMIN_GROUP_METAS_UPDATE_CONDITIONS_CC" as adminGroupMetasType),
    UPDATE_CONDITIONS_DAS: ("ADMIN_GROUP_METAS_UPDATE_CONDITIONS_DAS" as adminGroupMetasType),
    UPDATE_CONDITIONS_PPA: ("ADMIN_GROUP_METAS_UPDATE_CONDITIONS_PPA" as adminGroupMetasType),
    UPDATE_CONDITIONS_INTERNET: ("ADMIN_GROUP_METAS_UPDATE_CONDITIONS_INTERNET" as adminGroupMetasType),
    UPDATE_CONDITIONS_SERVICES_SUCCESS: ("ADMIN_GROUP_METAS_UPDATE_CONDITIONS_SERVICES_SUCCESS" as adminGroupMetasType),
    UPDATE_CONDITIONS_CC_SUCCESS: ("ADMIN_GROUP_METAS_UPDATE_CONDITIONS_CC_SUCCESS" as adminGroupMetasType),
    UPDATE_CONDITIONS_DAS_SUCCESS: ("ADMIN_GROUP_METAS_UPDATE_CONDITIONS_DAS_SUCCESS" as adminGroupMetasType),
    UPDATE_CONDITIONS_PPA_SUCCESS: ("ADMIN_GROUP_METAS_UPDATE_CONDITIONS_PPA_SUCCESS" as adminGroupMetasType),
    UPDATE_CONDITIONS_INTERNET_SUCCESS: ("ADMIN_GROUP_METAS_UPDATE_CONDITIONS_INTERNET_SUCCESS" as adminGroupMetasType),
    UPDATE_CONDITIONS_SERVICES_FAILURE: ("ADMIN_GROUP_METAS_UPDATE_CONDITIONS_SERVICES_FAILURE" as adminGroupMetasType),
    UPDATE_CONDITIONS_CC_FAILURE: ("ADMIN_GROUP_METAS_UPDATE_CONDITIONS_CC_FAILURE" as adminGroupMetasType),
    UPDATE_CONDITIONS_DAS_FAILURE: ("ADMIN_GROUP_METAS_UPDATE_CONDITIONS_DAS_FAILURE" as adminGroupMetasType),
    UPDATE_CONDITIONS_PPA_FAILURE: ("ADMIN_GROUP_METAS_UPDATE_CONDITIONS_PPA_FAILURE" as adminGroupMetasType),
    UPDATE_CONDITIONS_INTERNET_FAILURE: ("ADMIN_GROUP_METAS_UPDATE_CONDITIONS_INTERNET_FAILURE" as adminGroupMetasType)
};
export type adminGroupListType = "INIT" | "DESTROY" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE" | "DELETE" | "DELETE_SUCCESS" | "DELETE_FAILURE" | "CLICK_ADD" | "CLICK_EDIT" | "CLICK_CONFIGURATION" | "CLICK_DELETE" | "SELECT" | "SELECT_ORGANIZATION_GROUP" | "CLICK_SHOW_SERVICES" | "CLICK_SHOW_CODES" | "CLICK_SHOW_METAS" | "CLICK_ORGANIZATION_BACKLINK";
export const ADMIN_GROUP_LIST = {
    INIT: ("ADMIN_GROUP_LIST_INIT" as adminGroupListType),
    DESTROY: ("ADMIN_GROUP_LIST_DESTROY" as adminGroupListType),
    HYDRATE: ("ADMIN_GROUP_LIST_HYDRATE" as adminGroupListType),
    HYDRATE_SUCCESS: ("ADMIN_GROUP_LIST_HYDRATE_SUCCESS" as adminGroupListType),
    HYDRATE_FAILURE: ("ADMIN_GROUP_LIST_HYDRATE_FAILURE" as adminGroupListType),
    DELETE: ("ADMIN_GROUP_LIST_DELETE" as adminGroupListType),
    DELETE_SUCCESS: ("ADMIN_GROUP_LIST_DELETE_SUCCESS" as adminGroupListType),
    DELETE_FAILURE: ("ADMIN_GROUP_LIST_DELETE_FAILURE" as adminGroupListType),
    CLICK_ADD: ("ADMIN_GROUP_LIST_CLICK_ADD" as adminGroupListType),
    CLICK_EDIT: ("ADMIN_GROUP_LIST_CLICK_EDIT" as adminGroupListType),
    CLICK_CONFIGURATION: ("ADMIN_GROUP_LIST_CLICK_CONFIGURATION" as adminGroupListType),
    CLICK_DELETE: ("ADMIN_GROUP_LIST_CLICK_DELETE" as adminGroupListType),
    SELECT: ("ADMIN_GROUP_LIST_SELECT" as adminGroupListType),
    SELECT_ORGANIZATION_GROUP: ("ADMIN_GROUP_LIST_SELECT_ORGANIZATION_GROUP" as adminGroupListType),
    CLICK_SHOW_SERVICES: ("ADMIN_GROUP_LIST_CLICK_SHOW_SERVICES" as adminGroupListType),
    CLICK_SHOW_CODES: ("ADMIN_GROUP_LIST_CLICK_SHOW_CODES" as adminGroupListType),
    CLICK_SHOW_METAS: ("ADMIN_GROUP_LIST_CLICK_SHOW_METAS" as adminGroupListType),
    CLICK_ORGANIZATION_BACKLINK: ("ADMIN_GROUP_LIST_CLICK_ORGANIZATION_BACKLINK" as adminGroupListType)
};
export type adminParkListType = "INIT" | "DESTROY";
export const ADMIN_PARK_LIST = {
    INIT: ("ADMIN_PARK_LIST_INIT" as adminParkListType),
    DESTROY: ("ADMIN_PARK_LIST_DESTROY" as adminParkListType)
};
export type adminContractListType = "INIT" | "DESTROY" | "SYNC" | "SYNC_SUCCESS" | "SYNC_FAILURE" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE";
export const ADMIN_CONTRACT_LIST = {
    INIT: ("ADMIN_CONTRACT_LIST_INIT" as adminContractListType),
    DESTROY: ("ADMIN_CONTRACT_LIST_DESTROY" as adminContractListType),
    SYNC: ("ADMIN_CONTRACT_LIST_SYNC" as adminContractListType),
    SYNC_SUCCESS: ("ADMIN_CONTRACT_LIST_SYNC_SUCCESS" as adminContractListType),
    SYNC_FAILURE: ("ADMIN_CONTRACT_LIST_SYNC_FAILURE" as adminContractListType),
    HYDRATE: ("ADMIN_CONTRACT_LIST_HYDRATE" as adminContractListType),
    HYDRATE_SUCCESS: ("ADMIN_CONTRACT_LIST_HYDRATE_SUCCESS" as adminContractListType),
    HYDRATE_FAILURE: ("ADMIN_CONTRACT_LIST_HYDRATE_FAILURE" as adminContractListType)
};
export type adminServiceListType = "INIT" | "DESTROY" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE" | "DELETE" | "DELETE_SUCCESS" | "DELETE_FAILURE" | "CLICK_ADD" | "CLICK_EDIT" | "CLICK_DELETE" | "SELECT" | "SELECT_ORGANIZATION_GROUP" | "SELECT_ORGANIZATION" | "CLICK_ORGANIZATION_BACKLINK" | "CLICK_GROUP_BACKLINK";
export const ADMIN_SERVICE_LIST = {
    INIT: ("ADMIN_SERVICE_LIST_INIT" as adminServiceListType),
    DESTROY: ("ADMIN_SERVICE_LIST_DESTROY" as adminServiceListType),
    HYDRATE: ("ADMIN_SERVICE_LIST_HYDRATE" as adminServiceListType),
    HYDRATE_SUCCESS: ("ADMIN_SERVICE_LIST_HYDRATE_SUCCESS" as adminServiceListType),
    HYDRATE_FAILURE: ("ADMIN_SERVICE_LIST_HYDRATE_FAILURE" as adminServiceListType),
    DELETE: ("ADMIN_SERVICE_LIST_DELETE" as adminServiceListType),
    DELETE_SUCCESS: ("ADMIN_SERVICE_LIST_DELETE_SUCCESS" as adminServiceListType),
    DELETE_FAILURE: ("ADMIN_SERVICE_LIST_DELETE_FAILURE" as adminServiceListType),
    CLICK_ADD: ("ADMIN_SERVICE_LIST_CLICK_ADD" as adminServiceListType),
    CLICK_EDIT: ("ADMIN_SERVICE_LIST_CLICK_EDIT" as adminServiceListType),
    CLICK_DELETE: ("ADMIN_SERVICE_LIST_CLICK_DELETE" as adminServiceListType),
    SELECT: ("ADMIN_SERVICE_LIST_SELECT" as adminServiceListType),
    SELECT_ORGANIZATION_GROUP: ("ADMIN_SERVICE_LIST_SELECT_ORGANIZATION_GROUP" as adminServiceListType),
    SELECT_ORGANIZATION: ("ADMIN_SERVICE_LIST_SELECT_ORGANIZATION" as adminServiceListType),
    CLICK_ORGANIZATION_BACKLINK: ("ADMIN_SERVICE_LIST_CLICK_ORGANIZATION_BACKLINK" as adminServiceListType),
    CLICK_GROUP_BACKLINK: ("ADMIN_SERVICE_LIST_CLICK_GROUP_BACKLINK" as adminServiceListType)
};
export type adminMetasListType = "INIT" | "DESTROY" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE" | "DELETE" | "DELETE_SUCCESS" | "DELETE_FAILURE" | "CLICK_ADD" | "CLICK_EDIT" | "CLICK_DELETE" | "SELECT" | "SELECT_ORGANIZATION_GROUP" | "SELECT_ORGANIZATION" | "CLICK_ORGANIZATION_BACKLINK" | "CLICK_GROUP_BACKLINK";
export const ADMIN_METAS_LIST = {
    INIT: ("ADMIN_METAS_LIST_INIT" as adminMetasListType),
    DESTROY: ("ADMIN_METAS_LIST_DESTROY" as adminMetasListType),
    HYDRATE: ("ADMIN_METAS_LIST_HYDRATE" as adminMetasListType),
    HYDRATE_SUCCESS: ("ADMIN_METAS_LIST_HYDRATE_SUCCESS" as adminMetasListType),
    HYDRATE_FAILURE: ("ADMIN_METAS_LIST_HYDRATE_FAILURE" as adminMetasListType),
    DELETE: ("ADMIN_METAS_LIST_DELETE" as adminMetasListType),
    DELETE_SUCCESS: ("ADMIN_METAS_LIST_DELETE_SUCCESS" as adminMetasListType),
    DELETE_FAILURE: ("ADMIN_METAS_LIST_DELETE_FAILURE" as adminMetasListType),
    CLICK_ADD: ("ADMIN_METAS_LIST_CLICK_ADD" as adminMetasListType),
    CLICK_EDIT: ("ADMIN_METAS_LIST_CLICK_EDIT" as adminMetasListType),
    CLICK_DELETE: ("ADMIN_METAS_LIST_CLICK_DELETE" as adminMetasListType),
    SELECT: ("ADMIN_METAS_LIST_SELECT" as adminMetasListType),
    SELECT_ORGANIZATION_GROUP: ("ADMIN_METAS_LIST_SELECT_ORGANIZATION_GROUP" as adminMetasListType),
    SELECT_ORGANIZATION: ("ADMIN_METAS_LIST_SELECT_ORGANIZATION" as adminMetasListType),
    CLICK_ORGANIZATION_BACKLINK: ("ADMIN_METAS_LIST_CLICK_ORGANIZATION_BACKLINK" as adminMetasListType),
    CLICK_GROUP_BACKLINK: ("ADMIN_METAS_LIST_CLICK_GROUP_BACKLINK" as adminMetasListType)
};
export type adminNotesFormType = "INIT" | "DESTROY" | "CLICK_SUBMIT" | "UPDATE" | "UPDATE_SUCCESS" | "UPDATE_FAILURE";
export const ADMIN_NOTES_FORM = {
    INIT: ("ADMIN_NOTES_FORM_INIT" as adminNotesFormType),
    DESTROY: ("ADMIN_NOTES_FORM_DESTROY" as adminNotesFormType),
    CLICK_SUBMIT: ("ADMIN_NOTES_FORM_CLICK_SUBMIT" as adminNotesFormType),
    UPDATE: ("ADMIN_NOTES_FORM_UPDATE" as adminNotesFormType),
    UPDATE_SUCCESS: ("ADMIN_NOTES_FORM_UPDATE_SUCCESS" as adminNotesFormType),
    UPDATE_FAILURE: ("ADMIN_NOTES_FORM_UPDATE_FAILURE" as adminNotesFormType)
};
export type adminNotesListType = "INIT" | "DESTROY" | "CLICK_EDIT" | "SELECT" | "SELECT_PARK" | "CLICK_ORGANIZATION_BACKLINK" | "CLICK_GROUP_BACKLINK";
export const ADMIN_NOTES_LIST = {
    INIT: ("ADMIN_NOTES_LIST_INIT" as adminNotesListType),
    DESTROY: ("ADMIN_NOTES_LIST_DESTROY" as adminNotesListType),
    CLICK_EDIT: ("ADMIN_NOTES_LIST_CLICK_EDIT" as adminNotesListType),
    SELECT: ("ADMIN_NOTES_LIST_SELECT" as adminNotesListType),
    SELECT_PARK: ("ADMIN_NOTES_LIST_SELECT_PARK" as adminNotesListType),
    CLICK_ORGANIZATION_BACKLINK: ("ADMIN_NOTES_LIST_CLICK_ORGANIZATION_BACKLINK" as adminNotesListType),
    CLICK_GROUP_BACKLINK: ("ADMIN_NOTES_LIST_CLICK_GROUP_BACKLINK" as adminNotesListType)
};
export type adminAccessCodeSearchType = "INIT" | "DESTROY" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE";
export const ADMIN_ACCESS_CODE_SEARCH = {
    INIT: ("ADMIN_ACCESS_CODE_SEARCH_INIT" as adminAccessCodeSearchType),
    DESTROY: ("ADMIN_ACCESS_CODE_SEARCH_DESTROY" as adminAccessCodeSearchType),
    HYDRATE: ("ADMIN_ACCESS_CODE_SEARCH_HYDRATE" as adminAccessCodeSearchType),
    HYDRATE_SUCCESS: ("ADMIN_ACCESS_CODE_SEARCH_HYDRATE_SUCCESS" as adminAccessCodeSearchType),
    HYDRATE_FAILURE: ("ADMIN_ACCESS_CODE_SEARCH_HYDRATE_FAILURE" as adminAccessCodeSearchType)
};
export type adminUsersFormType = "INIT" | "DESTROY" | "CLICK_SUBMIT" | "UPDATE" | "UPDATE_SUCCESS" | "UPDATE_FAILURE";
export const ADMIN_USERS_FORM = {
    INIT: ("ADMIN_USERS_FORM_INIT" as adminUsersFormType),
    DESTROY: ("ADMIN_USERS_FORM_DESTROY" as adminUsersFormType),
    CLICK_SUBMIT: ("ADMIN_USERS_FORM_CLICK_SUBMIT" as adminUsersFormType),
    UPDATE: ("ADMIN_USERS_FORM_UPDATE" as adminUsersFormType),
    UPDATE_SUCCESS: ("ADMIN_USERS_FORM_UPDATE_SUCCESS" as adminUsersFormType),
    UPDATE_FAILURE: ("ADMIN_USERS_FORM_UPDATE_FAILURE" as adminUsersFormType)
};
export type adminUsersListType = "INIT" | "DESTROY" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE" | "CLICK_EDIT" | "SELECT" | "SELECT_USER" | "DELETE_USER" | "DELETE_USER_SUCCESS" | "DELETE_USER_FAILURE";
export const ADMIN_USERS_LIST = {
    INIT: ("ADMIN_USERS_LIST_INIT" as adminUsersListType),
    DESTROY: ("ADMIN_USERS_LIST_DESTROY" as adminUsersListType),
    HYDRATE: ("ADMIN_USERS_LIST_HYDRATE" as adminUsersListType),
    HYDRATE_SUCCESS: ("ADMIN_USERS_LIST_HYDRATE_SUCCESS" as adminUsersListType),
    HYDRATE_FAILURE: ("ADMIN_USERS_LIST_HYDRATE_FAILURE" as adminUsersListType),
    CLICK_EDIT: ("ADMIN_USERS_LIST_CLICK_EDIT" as adminUsersListType),
    SELECT: ("ADMIN_USERS_LIST_SELECT" as adminUsersListType),
    SELECT_USER: ("ADMIN_USERS_LIST_SELECT_USER" as adminUsersListType),
    DELETE_USER: ("ADMIN_USERS_LIST_DELETE_USER" as adminUsersListType),
    DELETE_USER_SUCCESS: ("ADMIN_USERS_LIST_DELETE_USER_SUCCESS" as adminUsersListType),
    DELETE_USER_FAILURE: ("ADMIN_USERS_LIST_DELETE_USER_FAILURE" as adminUsersListType)
};
export type adminCodeListType = "INIT" | "DESTROY" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE" | "SELECT_CODE_INDEX" | "SELECT_CODE_INDEX_SUCCESS" | "SELECT_CODE_INDEX_FAILURE" | "SELECT_FIRSTNAME_INDEX" | "SELECT_EXTRA_INDEX" | "SELECT_LASTNAME_INDEX" | "ENABLE_UPDATE" | "ENABLE_DELETE" | "ENABLE_ADD" | "ENABLE_IGNORE_HEADER" | "CANCEL_IMPORT" | "IMPORT_DATA_SUCCESS" | "IMPORT_DATA_FAILURE" | "IMPORT_DATA" | "DELETE" | "DELETE_SUCCESS" | "DELETE_FAILURE" | "CLICK_ADD" | "CLICK_IMPORT" | "CLICK_EDIT" | "CLICK_DELETE" | "SELECT" | "SELECT_ORGANIZATION_GROUP" | "SELECT_ORGANIZATION" | "CLICK_ORGANIZATION_BACKLINK" | "CLICK_GROUP_BACKLINK";
export const ADMIN_CODE_LIST = {
    INIT: ("ADMIN_CODE_LIST_INIT" as adminCodeListType),
    DESTROY: ("ADMIN_CODE_LIST_DESTROY" as adminCodeListType),
    HYDRATE: ("ADMIN_CODE_LIST_HYDRATE" as adminCodeListType),
    HYDRATE_SUCCESS: ("ADMIN_CODE_LIST_HYDRATE_SUCCESS" as adminCodeListType),
    HYDRATE_FAILURE: ("ADMIN_CODE_LIST_HYDRATE_FAILURE" as adminCodeListType),
    SELECT_CODE_INDEX: ("ADMIN_CODE_LIST_SELECT_CODE_INDEX" as adminCodeListType),
    SELECT_CODE_INDEX_SUCCESS: ("ADMIN_CODE_LIST_SELECT_CODE_INDEX_SUCCESS" as adminCodeListType),
    SELECT_CODE_INDEX_FAILURE: ("ADMIN_CODE_LIST_SELECT_CODE_INDEX_FAILURE" as adminCodeListType),
    SELECT_FIRSTNAME_INDEX: ("ADMIN_CODE_LIST_SELECT_FIRSTNAME_INDEX" as adminCodeListType),
    SELECT_EXTRA_INDEX: ("ADMIN_CODE_LIST_SELECT_EXTRA_INDEX" as adminCodeListType),
    SELECT_LASTNAME_INDEX: ("ADMIN_CODE_LIST_SELECT_LASTNAME_INDEX" as adminCodeListType),
    ENABLE_UPDATE: ("ADMIN_CODE_LIST_ENABLE_UPDATE" as adminCodeListType),
    ENABLE_DELETE: ("ADMIN_CODE_LIST_ENABLE_DELETE" as adminCodeListType),
    ENABLE_ADD: ("ADMIN_CODE_LIST_ENABLE_ADD" as adminCodeListType),
    ENABLE_IGNORE_HEADER: ("ADMIN_CODE_LIST_ENABLE_IGNORE_HEADER" as adminCodeListType),
    CANCEL_IMPORT: ("ADMIN_CODE_LIST_CANCEL_IMPORT" as adminCodeListType),
    IMPORT_DATA_SUCCESS: ("ADMIN_CODE_LIST_IMPORT_DATA_SUCCESS" as adminCodeListType),
    IMPORT_DATA_FAILURE: ("ADMIN_CODE_LIST_IMPORT_DATA_FAILURE" as adminCodeListType),
    IMPORT_DATA: ("ADMIN_CODE_LIST_IMPORT_DATA" as adminCodeListType),
    DELETE: ("ADMIN_CODE_LIST_DELETE" as adminCodeListType),
    DELETE_SUCCESS: ("ADMIN_CODE_LIST_DELETE_SUCCESS" as adminCodeListType),
    DELETE_FAILURE: ("ADMIN_CODE_LIST_DELETE_FAILURE" as adminCodeListType),
    CLICK_ADD: ("ADMIN_CODE_LIST_CLICK_ADD" as adminCodeListType),
    CLICK_IMPORT: ("ADMIN_CODE_LIST_CLICK_IMPORT" as adminCodeListType),
    CLICK_EDIT: ("ADMIN_CODE_LIST_CLICK_EDIT" as adminCodeListType),
    CLICK_DELETE: ("ADMIN_CODE_LIST_CLICK_DELETE" as adminCodeListType),
    SELECT: ("ADMIN_CODE_LIST_SELECT" as adminCodeListType),
    SELECT_ORGANIZATION_GROUP: ("ADMIN_CODE_LIST_SELECT_ORGANIZATION_GROUP" as adminCodeListType),
    SELECT_ORGANIZATION: ("ADMIN_CODE_LIST_SELECT_ORGANIZATION" as adminCodeListType),
    CLICK_ORGANIZATION_BACKLINK: ("ADMIN_CODE_LIST_CLICK_ORGANIZATION_BACKLINK" as adminCodeListType),
    CLICK_GROUP_BACKLINK: ("ADMIN_CODE_LIST_CLICK_GROUP_BACKLINK" as adminCodeListType)
};
export type adminMetasFormType = "INIT" | "DESTROY" | "CLICK_IMPORT" | "CLICK_ADD_ORGANIZATION" | "CLICK_ADD_GROUP" | "CLICK_ADD_OPTION" | "CLICK_EDIT_OPTION" | "CLICK_DELETE_OPTION" | "READ_FILE" | "READ_FILE_SUCCESS" | "READ_FILE_ERROR" | "ADD_OPTION" | "IMPORT_OPTIONS" | "UPDATE_OPTION" | "SELECT_OPTION" | "SELECT_ORGANIZATION_CODE" | "SELECT_GROUP_CODE" | "CLICK_SUBMIT" | "UPDATE_FORM" | "UPDATE" | "UPDATE_SUCCESS" | "UPDATE_FAILURE" | "ADD" | "ADD_SUCCESS" | "ADD_FAILURE";
export const ADMIN_METAS_FORM = {
    INIT: ("ADMIN_METAS_FORM_INIT" as adminMetasFormType),
    DESTROY: ("ADMIN_METAS_FORM_DESTROY" as adminMetasFormType),
    CLICK_IMPORT: ("ADMIN_METAS_FORM_CLICK_IMPORT" as adminMetasFormType),
    CLICK_ADD_ORGANIZATION: ("ADMIN_METAS_FORM_CLICK_ADD_ORGANIZATION" as adminMetasFormType),
    CLICK_ADD_GROUP: ("ADMIN_METAS_FORM_CLICK_ADD_GROUP" as adminMetasFormType),
    CLICK_ADD_OPTION: ("ADMIN_METAS_FORM_CLICK_ADD_OPTION" as adminMetasFormType),
    CLICK_EDIT_OPTION: ("ADMIN_METAS_FORM_CLICK_EDIT_OPTION" as adminMetasFormType),
    CLICK_DELETE_OPTION: ("ADMIN_METAS_FORM_CLICK_DELETE_OPTION" as adminMetasFormType),
    READ_FILE: ("ADMIN_METAS_FORM_READ_FILE" as adminMetasFormType),
    READ_FILE_SUCCESS: ("ADMIN_METAS_FORM_READ_FILE_SUCCESS" as adminMetasFormType),
    READ_FILE_ERROR: ("ADMIN_METAS_FORM_READ_FILE_ERROR" as adminMetasFormType),
    ADD_OPTION: ("ADMIN_METAS_FORM_ADD_OPTION" as adminMetasFormType),
    IMPORT_OPTIONS: ("ADMIN_METAS_FORM_IMPORT_OPTIONS" as adminMetasFormType),
    UPDATE_OPTION: ("ADMIN_METAS_FORM_UPDATE_OPTION" as adminMetasFormType),
    SELECT_OPTION: ("ADMIN_METAS_FORM_SELECT_OPTION" as adminMetasFormType),
    SELECT_ORGANIZATION_CODE: ("ADMIN_METAS_FORM_SELECT_ORGANIZATION_CODE" as adminMetasFormType),
    SELECT_GROUP_CODE: ("ADMIN_METAS_FORM_SELECT_GROUP_CODE" as adminMetasFormType),
    CLICK_SUBMIT: ("ADMIN_METAS_FORM_CLICK_SUBMIT" as adminMetasFormType),
    UPDATE_FORM: ("ADMIN_METAS_FORM_UPDATE_FORM" as adminMetasFormType),
    UPDATE: ("ADMIN_METAS_FORM_UPDATE" as adminMetasFormType),
    UPDATE_SUCCESS: ("ADMIN_METAS_FORM_UPDATE_SUCCESS" as adminMetasFormType),
    UPDATE_FAILURE: ("ADMIN_METAS_FORM_UPDATE_FAILURE" as adminMetasFormType),
    ADD: ("ADMIN_METAS_FORM_ADD" as adminMetasFormType),
    ADD_SUCCESS: ("ADMIN_METAS_FORM_ADD_SUCCESS" as adminMetasFormType),
    ADD_FAILURE: ("ADMIN_METAS_FORM_ADD_FAILURE" as adminMetasFormType)
};
export type adminCodeImportType = "INIT" | "DESTROY" | "READ_FILE" | "READ_FILE_SUCCESS" | "READ_FILE_ERROR";
export const ADMIN_CODE_IMPORT = {
    INIT: ("ADMIN_CODE_IMPORT_INIT" as adminCodeImportType),
    DESTROY: ("ADMIN_CODE_IMPORT_DESTROY" as adminCodeImportType),
    READ_FILE: ("ADMIN_CODE_IMPORT_READ_FILE" as adminCodeImportType),
    READ_FILE_SUCCESS: ("ADMIN_CODE_IMPORT_READ_FILE_SUCCESS" as adminCodeImportType),
    READ_FILE_ERROR: ("ADMIN_CODE_IMPORT_READ_FILE_ERROR" as adminCodeImportType)
};
export type adminCodeFormType = "INIT" | "DESTROY" | "CLICK_ADD_ORGANIZATION" | "CLICK_ADD_GROUP" | "SELECT_ORGANIZATION_CODE" | "SELECT_GROUP_CODE" | "CLICK_SUBMIT" | "UPDATE" | "UPDATE_SUCCESS" | "UPDATE_FAILURE" | "ADD" | "ADD_SUCCESS" | "ADD_FAILURE";
export const ADMIN_CODE_FORM = {
    INIT: ("ADMIN_CODE_FORM_INIT" as adminCodeFormType),
    DESTROY: ("ADMIN_CODE_FORM_DESTROY" as adminCodeFormType),
    CLICK_ADD_ORGANIZATION: ("ADMIN_CODE_FORM_CLICK_ADD_ORGANIZATION" as adminCodeFormType),
    CLICK_ADD_GROUP: ("ADMIN_CODE_FORM_CLICK_ADD_GROUP" as adminCodeFormType),
    SELECT_ORGANIZATION_CODE: ("ADMIN_CODE_FORM_SELECT_ORGANIZATION_CODE" as adminCodeFormType),
    SELECT_GROUP_CODE: ("ADMIN_CODE_FORM_SELECT_GROUP_CODE" as adminCodeFormType),
    CLICK_SUBMIT: ("ADMIN_CODE_FORM_CLICK_SUBMIT" as adminCodeFormType),
    UPDATE: ("ADMIN_CODE_FORM_UPDATE" as adminCodeFormType),
    UPDATE_SUCCESS: ("ADMIN_CODE_FORM_UPDATE_SUCCESS" as adminCodeFormType),
    UPDATE_FAILURE: ("ADMIN_CODE_FORM_UPDATE_FAILURE" as adminCodeFormType),
    ADD: ("ADMIN_CODE_FORM_ADD" as adminCodeFormType),
    ADD_SUCCESS: ("ADMIN_CODE_FORM_ADD_SUCCESS" as adminCodeFormType),
    ADD_FAILURE: ("ADMIN_CODE_FORM_ADD_FAILURE" as adminCodeFormType)
};
export type adminServiceFormType = "INIT" | "DESTROY" | "CLICK_ADD_ORGANIZATION" | "CLICK_ADD_GROUP" | "SELECT_ORGANIZATION_CODE" | "SELECT_GROUP_CODE" | "SELECT_PARK" | "SELECT_SERVICE" | "CLICK_SUBMIT" | "UPDATE" | "UPDATE_SUCCESS" | "UPDATE_FAILURE" | "ADD" | "ADD_SUCCESS" | "ADD_FAILURE";
export const ADMIN_SERVICE_FORM = {
    INIT: ("ADMIN_SERVICE_FORM_INIT" as adminServiceFormType),
    DESTROY: ("ADMIN_SERVICE_FORM_DESTROY" as adminServiceFormType),
    CLICK_ADD_ORGANIZATION: ("ADMIN_SERVICE_FORM_CLICK_ADD_ORGANIZATION" as adminServiceFormType),
    CLICK_ADD_GROUP: ("ADMIN_SERVICE_FORM_CLICK_ADD_GROUP" as adminServiceFormType),
    SELECT_ORGANIZATION_CODE: ("ADMIN_SERVICE_FORM_SELECT_ORGANIZATION_CODE" as adminServiceFormType),
    SELECT_GROUP_CODE: ("ADMIN_SERVICE_FORM_SELECT_GROUP_CODE" as adminServiceFormType),
    SELECT_PARK: ("ADMIN_SERVICE_FORM_SELECT_PARK" as adminServiceFormType),
    SELECT_SERVICE: ("ADMIN_SERVICE_FORM_SELECT_SERVICE" as adminServiceFormType),
    CLICK_SUBMIT: ("ADMIN_SERVICE_FORM_CLICK_SUBMIT" as adminServiceFormType),
    UPDATE: ("ADMIN_SERVICE_FORM_UPDATE" as adminServiceFormType),
    UPDATE_SUCCESS: ("ADMIN_SERVICE_FORM_UPDATE_SUCCESS" as adminServiceFormType),
    UPDATE_FAILURE: ("ADMIN_SERVICE_FORM_UPDATE_FAILURE" as adminServiceFormType),
    ADD: ("ADMIN_SERVICE_FORM_ADD" as adminServiceFormType),
    ADD_SUCCESS: ("ADMIN_SERVICE_FORM_ADD_SUCCESS" as adminServiceFormType),
    ADD_FAILURE: ("ADMIN_SERVICE_FORM_ADD_FAILURE" as adminServiceFormType)
};
export type adminFaqListGroupType = "INIT" | "DESTROY" | "CLICK_SHOW_QUESTIONS" | "CLICK_ADD" | "CLICK_ADD_GROUP" | "CLICK_EDIT" | "CLICK_DELETE" | "CLICK_DELETE_SUCCESS" | "CLICK_DELETE_FAILURE" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE";
export const ADMIN_FAQ_LIST_GROUP = {
    INIT: ("ADMIN_FAQ_LIST_GROUP_INIT" as adminFaqListGroupType),
    DESTROY: ("ADMIN_FAQ_LIST_GROUP_DESTROY" as adminFaqListGroupType),
    CLICK_SHOW_QUESTIONS: ("ADMIN_FAQ_LIST_GROUP_CLICK_SHOW_QUESTIONS" as adminFaqListGroupType),
    CLICK_ADD: ("ADMIN_FAQ_LIST_GROUP_CLICK_ADD" as adminFaqListGroupType),
    CLICK_ADD_GROUP: ("ADMIN_FAQ_LIST_GROUP_CLICK_ADD_GROUP" as adminFaqListGroupType),
    CLICK_EDIT: ("ADMIN_FAQ_LIST_GROUP_CLICK_EDIT" as adminFaqListGroupType),
    CLICK_DELETE: ("ADMIN_FAQ_LIST_GROUP_CLICK_DELETE" as adminFaqListGroupType),
    CLICK_DELETE_SUCCESS: ("ADMIN_FAQ_LIST_GROUP_CLICK_DELETE_SUCCESS" as adminFaqListGroupType),
    CLICK_DELETE_FAILURE: ("ADMIN_FAQ_LIST_GROUP_CLICK_DELETE_FAILURE" as adminFaqListGroupType),
    HYDRATE: ("ADMIN_FAQ_LIST_GROUP_HYDRATE" as adminFaqListGroupType),
    HYDRATE_SUCCESS: ("ADMIN_FAQ_LIST_GROUP_HYDRATE_SUCCESS" as adminFaqListGroupType),
    HYDRATE_FAILURE: ("ADMIN_FAQ_LIST_GROUP_HYDRATE_FAILURE" as adminFaqListGroupType)
};
export type adminFaqListType = "INIT" | "DESTROY" | "CLICK_ADD" | "CLICK_SHOW_GROUP" | "CLICK_ADD_GROUP" | "CLICK_EDIT" | "CLICK_DELETE" | "CLICK_DELETE_SUCCESS" | "CLICK_DELETE_FAILURE" | "HYDRATE" | "HYDRATE_SUCCESS" | "HYDRATE_FAILURE";
export const ADMIN_FAQ_LIST = {
    INIT: ("ADMIN_FAQ_LIST_INIT" as adminFaqListType),
    DESTROY: ("ADMIN_FAQ_LIST_DESTROY" as adminFaqListType),
    CLICK_ADD: ("ADMIN_FAQ_LIST_CLICK_ADD" as adminFaqListType),
    CLICK_SHOW_GROUP: ("ADMIN_FAQ_LIST_CLICK_SHOW_GROUP" as adminFaqListType),
    CLICK_ADD_GROUP: ("ADMIN_FAQ_LIST_CLICK_ADD_GROUP" as adminFaqListType),
    CLICK_EDIT: ("ADMIN_FAQ_LIST_CLICK_EDIT" as adminFaqListType),
    CLICK_DELETE: ("ADMIN_FAQ_LIST_CLICK_DELETE" as adminFaqListType),
    CLICK_DELETE_SUCCESS: ("ADMIN_FAQ_LIST_CLICK_DELETE_SUCCESS" as adminFaqListType),
    CLICK_DELETE_FAILURE: ("ADMIN_FAQ_LIST_CLICK_DELETE_FAILURE" as adminFaqListType),
    HYDRATE: ("ADMIN_FAQ_LIST_HYDRATE" as adminFaqListType),
    HYDRATE_SUCCESS: ("ADMIN_FAQ_LIST_HYDRATE_SUCCESS" as adminFaqListType),
    HYDRATE_FAILURE: ("ADMIN_FAQ_LIST_HYDRATE_FAILURE" as adminFaqListType)
};
export type adminFaqGroupEditType = "INIT" | "DESTROY" | "CANCEL" | "CLICK_BACK" | "SUBMIT" | "SUBMIT_SUCCESS" | "SUBMIT_FAILURE";
export const ADMIN_FAQ_GROUP_EDIT = {
    INIT: ("ADMIN_FAQ_GROUP_EDIT_INIT" as adminFaqGroupEditType),
    DESTROY: ("ADMIN_FAQ_GROUP_EDIT_DESTROY" as adminFaqGroupEditType),
    CANCEL: ("ADMIN_FAQ_GROUP_EDIT_CANCEL" as adminFaqGroupEditType),
    CLICK_BACK: ("ADMIN_FAQ_GROUP_EDIT_CLICK_BACK" as adminFaqGroupEditType),
    SUBMIT: ("ADMIN_FAQ_GROUP_EDIT_SUBMIT" as adminFaqGroupEditType),
    SUBMIT_SUCCESS: ("ADMIN_FAQ_GROUP_EDIT_SUBMIT_SUCCESS" as adminFaqGroupEditType),
    SUBMIT_FAILURE: ("ADMIN_FAQ_GROUP_EDIT_SUBMIT_FAILURE" as adminFaqGroupEditType)
};
export type adminFaqEditType = "INIT" | "DESTROY" | "CANCEL" | "CLICK_BACK" | "SUBMIT" | "SUBMIT_SUCCESS" | "SUBMIT_FAILURE";
export const ADMIN_FAQ_EDIT = {
    INIT: ("ADMIN_FAQ_EDIT_INIT" as adminFaqEditType),
    DESTROY: ("ADMIN_FAQ_EDIT_DESTROY" as adminFaqEditType),
    CANCEL: ("ADMIN_FAQ_EDIT_CANCEL" as adminFaqEditType),
    CLICK_BACK: ("ADMIN_FAQ_EDIT_CLICK_BACK" as adminFaqEditType),
    SUBMIT: ("ADMIN_FAQ_EDIT_SUBMIT" as adminFaqEditType),
    SUBMIT_SUCCESS: ("ADMIN_FAQ_EDIT_SUBMIT_SUCCESS" as adminFaqEditType),
    SUBMIT_FAILURE: ("ADMIN_FAQ_EDIT_SUBMIT_FAILURE" as adminFaqEditType)
};
export type ppaAddType = "INIT" | "DESTROY" | "SUBMIT" | "SUBMIT_SUCCESS" | "SUBMIT_FAILURE" | "FORM_UPDATE";
export const PPA_ADD = {
    INIT: ("PPA_ADD_INIT" as ppaAddType),
    DESTROY: ("PPA_ADD_DESTROY" as ppaAddType),
    SUBMIT: ("PPA_ADD_SUBMIT" as ppaAddType),
    SUBMIT_SUCCESS: ("PPA_ADD_SUBMIT_SUCCESS" as ppaAddType),
    SUBMIT_FAILURE: ("PPA_ADD_SUBMIT_FAILURE" as ppaAddType),
    FORM_UPDATE: ("PPA_ADD_FORM_UPDATE" as ppaAddType)
};
export type monerisType = "HYDRATE";
export const MONERIS = {
    HYDRATE: ("MONERIS_HYDRATE" as monerisType)
};
export type monerisPaypageType = "INIT" | "DESTROY" | "SHOW_IFRAME" | "HIDE_IFRAME" | "CLICK_RETRY";
export const MONERIS_PAYPAGE = {
    INIT: ("MONERIS_PAYPAGE_INIT" as monerisPaypageType),
    DESTROY: ("MONERIS_PAYPAGE_DESTROY" as monerisPaypageType),
    SHOW_IFRAME: ("MONERIS_PAYPAGE_SHOW_IFRAME" as monerisPaypageType),
    HIDE_IFRAME: ("MONERIS_PAYPAGE_HIDE_IFRAME" as monerisPaypageType),
    CLICK_RETRY: ("MONERIS_PAYPAGE_CLICK_RETRY" as monerisPaypageType)
};
export type monerisVaultType = "INIT" | "DESTROY" | "SHOW_IFRAME" | "HIDE_IFRAME" | "CLICK_RETRY";
export const MONERIS_VAULT = {
    INIT: ("MONERIS_VAULT_INIT" as monerisVaultType),
    DESTROY: ("MONERIS_VAULT_DESTROY" as monerisVaultType),
    SHOW_IFRAME: ("MONERIS_VAULT_SHOW_IFRAME" as monerisVaultType),
    HIDE_IFRAME: ("MONERIS_VAULT_HIDE_IFRAME" as monerisVaultType),
    CLICK_RETRY: ("MONERIS_VAULT_CLICK_RETRY" as monerisVaultType)
};
